<template>

  <div id="sidebar-wrapper" style="scrollbar-width: none;">
    <ul class="sidebar-nav nav-pills nav-stacked fleet-side-bar mCustomScrollbar" id="menu"
      style="height: 90%; overflow: auto;">

      <template v-if="!isEv">
        <template v-if="menudashboard === true && role !== 'end customer'">
          <li id="dashboardLink">
            <router-link @click.native="dashbord()" :to="'void(0)'" class='removeActive'>
              <i class="fp-dashboard"> </i>
              Work Queue
            </router-link>
          </li>
        </template>
        <template v-if="loadMenuLinksFor == 'modules' && role !== 'end customer'">
          <li id="customerTabLink"
              v-if="menucustomer === true || menucustomercontact === true || menucredit === true ||menuach === true">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-customer"> </i>
                Customers
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <template v-if="menucustomer === true">
                <li id="customerLink">
                  <router-link v-bind:to="{ path:'/dealer/list'}">
                    Customers
                  </router-link>
                </li>
              </template>
              <!-- <template v-if="menucustomercontact === true">
                            <li id="customercontactLink">
                                <router-link v-bind:to="{ path:'/customercontact/list'}">
                                    Customer Contacts
                                </router-link>
                            </li>
                        </template> -->
              <template v-if="menucredit === true">
                <li id="creditLink">
                  <router-link v-bind:to="{ path:'/customer-credit-details/list'}">
                    Customer Credit Details
                  </router-link>
                </li>
              </template>
              <template v-if="menuach === true">
                <li id="achLink">
                  <router-link v-bind:to="{ path:'/customer-ach-details/list'}" href="/customer-ach-details/list">
                    Customer ACH Details
                  </router-link>
                </li>
              </template>
              <template v-if="menutypedeposit === true">
                <li id="typedeposit">
                  <router-link v-bind:to="{ path:'/asset-deposit-type/list'}" href="/asset-deposit-type/list">
                    Asset Type Deposit
                  </router-link>
                </li>
              </template>
            </ul>
          </li>
          <li v-if="menuVechicle === true && role !== 'customer'" id="assetTabLink">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-truck-asset"> </i>
                Asset Management
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <template v-if="menuVechicle === true">
                <li id="vehicleLink">
                  <router-link v-bind:to="{ path:'/asset/list'}">
                    Assets
                  </router-link>
                </li>
              </template>
              <template v-if="menuvehicletype === true">
                <li id="vehicleTypeLink">
                  <router-link v-bind:to="{ path:'/assettypes/list'}" href="/assettypes/list">
                    Types
                  </router-link>
                </li>
              </template>
              <template v-if="menuvehiclegroup === true">
                <li id="vehicleGroupLink">
                  <router-link v-bind:to="{ path:'/assetgroup/list'}" href="/assetgroup/list">
                    Groups
                  </router-link>
                </li>
              </template>

              <template v-if="requisition === true">
                <li id="requisitionLink">
                  <router-link v-bind:to="{ path:'/asset-requisition/list'}" href="/asset-requisition/list">
                    Requisition
                  </router-link>
                </li>
              </template>
              <template v-if="menupurchaseorderassetdetail === true">
                <li id="purchaseorderassetdetailLink">
                  <router-link v-bind:to="{ path:'/asset-purchase-order/list'}" href="/asset-purchase-order/list">
                    Purchase Order
                  </router-link>
                </li>
              </template>


              <!--<template v-if="menuassetcomponent === true">
                            <li id="assetcomponent">
                                <router-link v-bind:to="{ path:'/assetcomponent/list'}" href="/assetcomponent/list">
                                    Component
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuassetfeature === true">
                            <li id="assetfeature">
                                <router-link v-bind:to="{ path:'/assetfeature/list'}" href="/assetfeature/list">
                                    Standard Features
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuvehicledefect === true">
                            <li id="vehicledefectLink">
                                <router-link v-bind:to="{ path:'/assetdefect/list'}" class='removeActive'>
                                    Defects
                                </router-link>
                            </li>
                        </template>-->

              <!-- <template v-if="menuvehiclelocationhistory === true">
                            <li id="vehiclelocationhistoryLink">
                                <router-link v-bind:to="{ path:'/assetlocation/list'}" class='removeActive'>
                                    Assets Location History
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuvehiclecontracthistory === true">
                            <li id="vehiclecontracthistoryLink">
                                <router-link v-bind:to="{ path:'/assetcontract/list'}" class='removeActive'>
                                    Assets Contract History
                                </router-link>
                            </li>
                        </template> -->
              <template v-if="menuvehiclelogs === true">
                <li id="vehiclelogLink">
                  <router-link v-bind:to="{ path:'/asset-log/list'}" class='removeActive'>
                    Log
                  </router-link>
                </li>
              </template>
              <template v-if="menuvehiclesale === true">
                <li id="vehiclesaleLink">
                  <router-link v-bind:to="{ path:'/asset-sale/list'}" class='removeActive'>
                    Sales
                  </router-link>
                </li>
              </template>
              <!-- <template v-if="menuvehiclesale === true">
                            <li id="customerOrderPrices">
                                <router-link v-bind:to="{ path:'/customer-order-pricing/list'}" class='removeActive'>
                                    Customer Order Prices
                                </router-link>
                            </li>
                        </template> -->
              <template v-if="menucapitalcost === true">
                <li id="capitalCostLink">
                  <router-link v-bind:to="{ path:'/capital-cost-analysis/list'}" href="/capital-cost-analysis/list"
                               class='removeActive'>
                    Capital Cost Analysis
                  </router-link>
                </li>
              </template>

            </ul>
          </li>

          <li id="rentalTabLink"
              v-if="(menuitemrental === true || menurentalagreement==true || menucustomerdiscount === true || menuscoperate === true)">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-rental-truck"> </i>
                Rental
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <template v-if="menuitemrental === true">
                <li id="reservationRentalTabLink">
                  <router-link v-bind:to="{ path:'/reservation/rental'}" href="/reservation/rental">
                    Reservations
                  </router-link>
                </li>
              </template>
              <template v-if="menurentalagreement === true">
                <li id="rentalagreementLink">
                  <router-link v-bind:to="{ path:'/rentalagreement/list'}" href="/rentalagreement/list">
                    Agreements
                  </router-link>
                </li>
              </template>
              <template v-if="menurentalpo === true">
                <li id="rentalpoLink">
                  <router-link v-bind:to="{ path:'/order-history/list?from=cust_po_wo&type=contract&by=rent'}"
                               href="/order-history/list?from=cust_po_wo&type=contract&by=rent">
                    Customer PO
                  </router-link>
                </li>
              </template>
              <!--new change-->
              <li id="scopeheaderLink" v-if="menuscoperate === true || menucustomerdiscount === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Rate Rules & Disc.
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menuscoperate === true">
                    <li id="scoperateLink">
                      <router-link v-bind:to="{ path:'/scoperate/list'}" href="/scoperate/list">
                        Discount Rates
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuscoperate === true">
                    <li id="scopeheaderrateLink">
                      <router-link v-bind:to="{ path:'/scope-header/list'}" href="/scope-header/list">
                        Rate Rule Headers
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menucustomerdiscount === true">
                    <li id="customerdiscountLink">
                      <router-link v-bind:to="{ path:'/customer-discount/list'}" href="/customer-discount/list">
                        Customer Discount
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>

            </ul>
          </li>
          <li id="leaseTabLink" v-if=" ((menuitemlease === true)
                    || (menucontract === true) || menucpiproofreview === true)">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-rental"> </i>
                Lease
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <!-- <template v-if="menuitemlease === true && role == 'admin'">
                            <li id="reservationLeaseTabLink">
                                <router-link v-bind:to="{ path:'/reservation/lease'}" href="/reservation/lease">
                                    Reservations
                                </router-link>
                            </li>
                        </template> -->
              <template v-if="menucontract === true">
                <li id="contractLink">
                  <router-link v-bind:to="{ path:'/contract/list'}" href="/contract/list" class='removeActive'>
                    Contracts
                  </router-link>
                </li>
                <li id="contractunitdetailLink">
                  <router-link v-bind:to="{ path:'/contractassetdetail/list'}" href="/contractassetdetail/list">
                    Contract Assets
                  </router-link>
                </li>
              </template>
              <template v-if="menucpiproofreview === true">
                <li id="cpiproofreviewLink">
                  <router-link v-bind:to="{ path:'/cpiproofreview/list'}" href="/cpiproofreview/list">
                    CPI Proof Review
                  </router-link>
                </li>
              </template>
            </ul>
          </li>
          <!-- <li id="scopeheaderLink" v-if="menuscoperate === true || menucustomerdiscount === true">
                    <label class="tree-toggle nav-header">
                        <a href="javascript:void(0)">
                            <i class="fp-scope-rate"></i>
                            Rate Rules & Discount
                            <i aria-hidden="true" class="fp-down-arrow"></i>
                        </a>
                    </label>
                    <ul class="nav tree">
                        <template v-if="menuscoperate === true">
                            <li id="scoperateLink">
                                <router-link v-bind:to="{ path:'/scoperate/list'}" href="/scoperate/list">
                                    Discount Rates
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuscoperate === true">
                            <li id="scopeheaderrateLink">
                                <router-link v-bind:to="{ path:'/scope-header/list'}" href="/scope-header/list">
                                    Rate Rule Headers
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menucustomerdiscount === true">
                            <li id="customerdiscountLink">
                                <router-link v-bind:to="{ path:'/customer-discount/list'}" href="/customer-discount/list">
                                    Customer Discount
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </li> -->
          <li id="insuranceTabLink"
              v-if="(menuinsurancepolicy === true || menuinsurancecompany==true || menuinsuranceagency==true || menuinsurancecertificate==true)">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-insurance-truck"> </i>
                Insurance
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <template v-if="menuinsurancepolicy === true">
                <li id="insurancePolicyLink">
                  <router-link v-bind:to="{ path:'/insurancepolicy/list'}" href="/insurancepolicy/list">
                    Insurance Policies
                  </router-link>
                </li>
              </template>
              <template v-if="menuinsurancecompany === true">
                <li id="insurancecompanyLink">
                  <router-link v-bind:to="{ path:'/insurancecompany/list'}" href="/insurancecompany/list">
                    Insurance Company
                  </router-link>
                </li>
              </template>
              <template v-if="menuinsuranceagency === true">
                <li id="insuranceAgencyLink">
                  <router-link v-bind:to="{ path:'/insuranceagency/list'}" href="/insuranceagency/list">
                    Insurance Agency
                  </router-link>
                </li>
              </template>
              <!-- this is not required as team will use some other application -->
              <!-- <template v-if="menuinsurancecertificate === true">
                            <li id="insuranceAgencyLink">
                                <router-link v-bind:to="{ path:'/insurance-certificate/list'}" href="/insurance-certificate/list">
                                    Insurance Certificate
                                </router-link>
                            </li>
                        </template> -->

            </ul>
          </li>

          <li id="maintenanceTabLink" v-if="(menuschedule === true || menuworkorder === true || menuworkorderestimate === true || menupurchaseorderdetail === true
                    || menuworkordertemplate === true || defaultpricebook == true || pricebookhistory == true || menuapprovedworkorder == true || menushiftdetail == true
                    || menuworkorderinvoice === true || poreceipt === true || menuleaveholidaycalendar === true)">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-administrator-developer"></i>
                Maintenance
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <template v-if="menuschedule === true">
                <li id="scheduleTabLink">
                  <router-link v-on:click.native="showCalendarPage" v-bind:to="{ path:'/maintenance-schedule'}"
                               href="/maintenance-schedule">
                    Schedule
                  </router-link>
                </li>
              </template>
              <template v-if="menuworkorder === true">
                <li id="workOrderLink">
                  <router-link v-bind:to="{ path:'/workorder/list'}" href="/workorder/list">
                    Work Order
                  </router-link>
                </li>
              </template>
              <!-- <template v-if="menuapprovedworkorder === true">
                            <li id="approvedWorkOrderLink">
                                <router-link v-bind:to="{ path:'/approved-workorder/list'}" href="/approved-workorder/list">
                                    Approved Work Order
                                </router-link>
                            </li>
                        </template> -->
              <template v-if="menuworkorderestimate === true">
                <li id="workOrderEstimateLink">
                  <router-link v-bind:to="{ path:'/estimate'}" href="/estimate">
                    Estimate
                  </router-link>
                </li>
              </template>
              <template v-if="menupurchaseorderdetail === true">
                <li id="purchaseorderdetailLink">
                  <router-link v-bind:to="{ path:'/order-history/list'}" href="/order-history/list">
                    Vendor PO
                  </router-link>
                </li>
              </template>

              <template v-if="menurentalpo === true">
                <li id="customerpurchaseorderdetailLink">
                  <router-link v-bind:to="{ path:'/order-history/list?from=cust_po_wo&type=contract'}"
                               href="/order-history/list?from=cust_po_wo&type=contract">
                    Customer PO
                  </router-link>
                </li>
              </template>

              <!-- <template v-if="menurecallassetmapper === true">
                            <li id="recallAssetMapperLink">
                                <router-link v-bind:to="{ path:'/recall-asset-mapper'}" href="/recall-asset-mapper">
                                Recall Asset Mapping
                                </router-link>
                            </li>
                        </template> -->
              <!-- <template v-if="menuworkordertemplate=== true">
                            <li id="workordertemplateLink">
                                <router-link v-bind:to="{ path:'/workordertemplate/list'}" href="/workordertemplate/list">
                                    Work Order Template
                                </router-link>
                            </li>
                        </template> -->
              <template v-if="defaultpricebook=== true">
                <li id="defaultpricebookLink">
                  <router-link v-bind:to="{ path:'/price-book/create'}" href="/price-book/create">
                    Price Book
                  </router-link>
                </li>
              </template>
              <template v-if="pricebookhistory=== true">
                <li id="pricebookhistoryLink">
                  <router-link v-bind:to="{ path:'/price-book-history/list'  , query: { flag : 'priceLog' }}"
                               href="/price-book-history/list?flag=priceLog">
                    Price Book History
                  </router-link>
                </li>
              </template>
              <template v-if="menulaborcost=== true">
                <li id="laborCostLink">
                  <router-link v-bind:to="{ path:'/labor-cost/list'}" href="/labor-cost/list">
                    Labor Cost
                  </router-link>
                </li>
              </template>
              <template v-if="menushiftdetail=== true">
                <li id="shiftDetailLink">
                  <router-link v-bind:to="{ path:'/shift-detail/list'}" href="/shift-detail/list">
                    Shift Detail
                  </router-link>
                </li>
              </template>
              <template v-if="menuvmrs=== true">
                <li id="vmrsLink">
                  <router-link v-bind:to="{ path:'/vmrs-code/list'}" href="/vmrs-code/list">
                    VMRS Code
                  </router-link>
                </li>
              </template>
              <template v-if="menuvmrs=== true">
                <li id="programLink">
                  <router-link v-bind:to="{ path:'/program/list'}" href="/program/list">
                    Program
                  </router-link>
                </li>
              </template>
              <template v-if="menuoutofservice === true">
                <li id="oosLink">
                  <router-link v-bind:to="{ path:'/out-of-service/list'}" href="/out-of-service/list">
                    Out Of Service
                  </router-link>
                </li>
              </template>

              <template v-if="menuworkorderinvoice === true">
                <li id="woInvoiceLink">
                  <router-link v-bind:to="{ path:'/workorder/invoice/list'}" href="/workorder/invoice/list">
                    Work Order Invoice
                  </router-link>
                </li>
              </template>
              <template v-if="poreceipt === true">
                <li id="poreceiptLink">
                  <router-link v-bind:to="{ path:'/record-receipt/list'}" href="/record-receipt/list">
                    Receipt
                  </router-link>
                </li>
              </template>
              <template v-if="menuleaveholidaycalendar === true">
                <li id="leaveHolidayTabLink">
                  <router-link v-on:click.native="showLeaveHolidayPage" v-bind:to="{ path:'/leave-holiday/calendar'}"
                               href="/leave-holiday/calendar">
                    Leave/Holiday Calendar
                  </router-link>
                </li>
              </template>
            </ul>
          </li>
          <li id="inventoryTabLink"
              v-if="(menuitem === true || poreceipt === true || menuitemManufacturer === true || menuitemcategories === true || menuwarehouse === true || comptransaction === true || menusuggestedorder === true) && role != 'customer'">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-inventory"> </i>
                Inventory
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <template v-if="menuitem === true">
                <li id="itemLink">
                  <router-link v-bind:to="{ path:'/part/list'}" href="/part/list">
                    Parts
                  </router-link>
                </li>
              </template>
              <template v-if="menupurchaseorderdetail === true">
                <li id="itemPurchageOrderLink">
                  <router-link v-bind:to="{ path:'/item-purchase-order/list?from=item'}"
                               href="/item-purchase-order/list?from=item">
                    Purchase Order
                  </router-link>
                </li>
              </template>
              <template v-if="menuitemManufacturer === true">
                <li id="itemManufacturerLink">
                  <router-link v-bind:to="{ path:'/part-manufacturer/list'}" href="/part-manufacturer/list">
                    Manufacturers
                  </router-link>
                </li>
              </template>
              <template v-if="menuitemcategories === true">
                <li id="itemcategoryLink">
                  <router-link v-bind:to="{ path:'/part-categories/list'}" href="/part-categories/list">
                    Categories
                  </router-link>
                </li>
              </template>
              <template v-if="menuwarehouse === true">
                <li id="warehouseLink">
                  <router-link v-bind:to="{ path:'/warehouse/list'}" href="/warehouse/list">
                    Warehouse
                  </router-link>
                </li>
              </template>
              <template v-if="menuwarehouseBinMapper === true">
                <li id="warehouseBinMapperLink">
                  <router-link v-bind:to="{ path:'/warehouse-bin-mapper/list'}" href="/warehouse-bin-mapper/list">
                    Warehouse Bin Map
                  </router-link>
                </li>
              </template>
              <template v-if="poreceipt === true">
                <li id="poreceiptLink">
                  <router-link v-bind:to="{ path:'/record-receipt/list'}" href="/record-receipt/list">
                    Receipt
                  </router-link>
                </li>
              </template>
              <template v-if="physicalCountList === true">
                <li id="physicalCountLink">
                  <router-link v-bind:to="{ path:'/physical-count/list'}" href="/physical-count/list">
                    Physical Count
                  </router-link>
                </li>
              </template>
              <template v-if="menusuggestedorder === true">
                <li id="suggestedOrderLink">
                  <router-link v-bind:to="{ path:'/suggested-order/list'}" href="/suggested-order/list">
                    Suggested Order
                  </router-link>
                </li>
              </template>
            </ul>
          </li>

          <li id="etkTabLink"
              v-if="(etkrequest === true || menuuserlogentry === true || indirectcoderequest === true || menugangsheet === true)">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-log-file-format"></i>
                Time Keeping
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <template v-if="etkrequest">
                <li id="workEntryLink">
                  <router-link v-bind:to="{ path:'/work-entry/time'}" href="/work-entry/time">
                    Log time
                  </router-link>
                </li>
              </template>
              <template v-if="indirectcoderequest">
                <li id="laborCodeLink">
                  <router-link v-bind:to="{ path:'/etk/list'}" href="/etk/list">
                    Labor Code
                  </router-link>
                </li>
              </template>
              <!-- <template v-if="menuuserlogentry">
                        <li id="userLogEntry">
                            <router-link v-bind:to="{ path:'/user-log-entry'}" href="/user-log-entry">
                                User Log Entry
                            </router-link>
                        </li>
                        </template> -->
              <template v-if="menugangsheet">
                <li id="gangSheetLink">
                  <router-link v-bind:to="{ path:'/gang-sheet'}" href="/gang-sheet">
                    Gang Sheet
                  </router-link>
                </li>
              </template>
            </ul>
          </li>

          <li id="fuelTabLink"
              v-if="(menufuelticket === true || menufuelreading === true || menufuelislandproduct === true || menufueldrop === true || menufuelpricing === true)">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-gasoline-pump"> </i>
                Fuel
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">

              <li id="fuelTicketLink" v-if="menufuelticket === true">
                <router-link v-bind:to="{ path:'/fuel-ticket/list'}" href="/fuel-ticket/list">
                  Fuel Ticket
                </router-link>
              </li>

              <li id="fuelReadingLink" v-if="menufuelreading == true">
                <router-link v-bind:to="{ path:'/fuel-reading/list'}" href="/fuel-reading/list">
                  Fuel Reading
                </router-link>
              </li>

              <li id="fuelislandProductLink" v-if="menufuelislandproduct === true">
                <router-link v-bind:to="{ path:'/fuel-island-product/list'}" href="/fuel-island-product/list">
                  Fuel Island Product
                </router-link>
              </li>
              <li id="fuelTankPumpMapperLink" v-if="menufuelticket === true">
                <router-link v-bind:to="{ path:'/fuel-pump-map/list'}" href="/fuel-pump-map/list">
                  Tank Pump Mapper
                </router-link>
              </li>

              <li id="fuelDropLink" v-if="menufueldrop === true">
                <router-link v-bind:to="{ path:'/fuel-drop/list'}" href="/fuel-drop/list">
                  Fuel Drops
                </router-link>
              </li>

              <li id="fuelPricingLink" v-if="menufuelpricing === true">
                <router-link v-bind:to="{ path:'/fuel-pricing/list'}" href="/fuel-pricing/list">
                  Fuel Pricing
                </router-link>
              </li>

              <li id="fuelPriceLogLink" v-if="menufuelpricing === true">
                <router-link v-bind:to="{ path:'/fuel-price/log'}" href="/fuel-price/log">
                  Price Log
                </router-link>
              </li>


            </ul>
          </li>

          <li id="warrantyTabLink" v-if="menuwarranties === true && role != 'customer'">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-warranty"></i>
                Warranty
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <template>
                <li id="warrantyLink">
                  <router-link v-bind:to="{ path:'/warranty/list'}" href="/warranty/list">
                    Warranty
                  </router-link>
                </li>
              </template>
              <template>
                <li id="claimLink">
                  <router-link v-bind:to="{ path:'/warranty-claim/list'}" href="/warranty-claim/list">
                    Claims
                  </router-link>
                </li>
              </template>
              <template>
                <li id="collectionLink">
                  <router-link v-bind:to="{ path:'/list/claim-collection'}" href="/list/claim-collection">
                    Collections
                  </router-link>
                </li>
              </template>
            </ul>
          </li>
          <li id="permitTabLink"
              v-if="(menuvehiclepermit === true || menuvehiclehvut === true || menuvehiclepermittype === true)">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-transport-request-form"> </i>
                Permits
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <template v-if="menuvehiclepermit === true">
                <li id="vehiclepermitLink">
                  <router-link v-bind:to="{ path:'/vehiclepermit/list'}" href="/vehiclepermit/list">
                    Permits
                  </router-link>
                </li>
              </template>
              <template v-if="menuvehiclehvut === true">
                <li id="vehiclehvutLink">
                  <router-link v-bind:to="{ path:'/fhut-schedule/list'}" href="/fhut-schedule/list">
                    FHUT
                  </router-link>
                </li>
              </template>
              <template v-if="menuhvutcategory === true">
                <li id="fhutCategoryLink">
                  <router-link v-bind:to="{ path:'/fhut-categories/list'}" href="/fhut-categories/list">
                    FHUT Categories
                  </router-link>
                </li>
              </template>
              <template v-if="menuhvutexception === true">
                <li id="fhutExceptionLink">
                  <router-link v-bind:to="{ path:'/fhut-exception/list'}" href="/fhut-exception/list">
                    FHUT Exceptions
                  </router-link>
                </li>
              </template>
              <template v-if="menuvehiclepermittype === true">
                <li id="vehiclepermittypeLink">
                  <router-link v-bind:to="{ path:'/vehiclepermittype/list'}" href="/vehiclepermittype/list">
                    Permit Type
                  </router-link>
                </li>
              </template>
              <template v-if="menucitation === true">
                <li id="citationLink">
                  <router-link v-bind:to="{ path:'/citation/list'}" href="/citation/list">
                    Citation
                  </router-link>
                </li>
              </template>
            </ul>
          </li>

          <li id="noticeTabLink"
              v-if="(menucourtesynotice === true || menupastduenotice === true || menuunitreading === true || menuachnotice === true)">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-profiles"> </i>
                Customer Notices
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <template v-if="menucourtesynotice === true">
                <li id="courtesyNoticeLink">
                  <router-link v-bind:to="{ path:'/notice/courtesy'}" href="/notice/courtesy">
                    Courtesy
                  </router-link>
                </li>
              </template>
              <template v-if="menupastduenotice === true">
                <li id="pastDueNoticeLink">
                  <router-link v-bind:to="{ path:'/notice/past-due'}" href='/notice/past-due'>
                    Past Due
                  </router-link>
                </li>
              </template>
              <template v-if="menuunitreading === true">
                <li id="unitReadinglistlink">
                  <router-link v-bind:to="{ path:'/reading-notification'}" href="/reading-notification">
                    Unit Readings
                  </router-link>
                </li>
              </template>
              <template v-if="menuachnotice === true">
                <li id="noticeACHlistlink">
                  <router-link v-bind:to="{ path:'/notice/ach'}" href="/notice/ach">
                    ACH Notice
                  </router-link>
                </li>
              </template>
            </ul>
          </li>


          <li id="accountTabLink" v-if="(menuinvoice === true || menupayment === true || menureceipt===true || menuvendor === true
                    || menubill===true || menucreditnote===true || menuvendorpayment===true || menucheck===true || menutransfer===true ||
                    menudebtNote===true || menudebtNoteReconciliation===true || menuglaccount===true
                    || menujournal===true || menuglreport===true || menuaccountsrececivableinquiry === true
                     || menurefundpaymentlist === true || menurefundeligiblelist === true || menuvoucherpayment === true)">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-accounting"> </i>
                Accounting
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">

              <li id="accountRecLink" v-if="menuinvoice === true || menupayment === true || menureceipt === true || menuaccountsrececivableinquiry === true
                        || menurefundpaymentlist === true || menurefundeligiblelist === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Accounts Receivable
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menurefundeligiblelist === true">
                    <li id="refundEligibleList">
                      <router-link v-bind:to="{ path:'/refund-eligible-list'}" href="/refund-eligible-list">
                        Eligible Customer for Refund
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menurefundpaymentlist === true">
                    <li id="refundPaymentList">
                      <router-link v-bind:to="{ path:'/refund-payment-list'}" href="/refund-payment-list">
                        Refund Payment Maintenance
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuinvoice === true">
                    <li id="invoiceLink">
                      <router-link v-bind:to="{ path:'/invoice/list'}" href="/invoice/list">
                        Customer Invoices
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuinvoice === true">
                    <li id="invoiceLink">
                      <router-link v-bind:to="{ path:'/corcentric-invoices-extract'}"
                                   href="/corcentric-invoices-extract">
                        Corcentric Invoice Extract
                      </router-link>
                    </li>
                  </template>
                  <!-- <template v-if="menupayment === true">
                                    <li id="paymentLink">
                                        <router-link v-bind:to="{ path:'/payment/list'}" href="/payment/list">
                                            Payments
                                        </router-link>
                                    </li>
                                </template> -->
                  <template v-if="menubillingforecast === true">
                    <li id="billingForecastReportLink">
                      <router-link v-bind:to="{ path:'/billing-forecast/list'}" href="/billing-forecast/list">
                        Billing Forecast
                      </router-link>
                    </li>
                  </template>
                  <!-- <template v-if="menureceipt === true">
                                    <li id="receiptLink">
                                        <router-link v-bind:to="{ path:'/payment-receipt/list'}" href="/payment-receipt/list">
                                            Payment Receipt
                                        </router-link>
                                    </li>
                                </template> -->
                  <template v-if="menuinvoice === true">
                    <li id="statementLink">
                      <router-link v-bind:to="{ path:'/customer-statement'}" href="/customer-statement">
                        Customer Statement
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
              <li id="accountPayLink" v-if="menuvendor === true || menubill === true || menucreditnote === true || menuvendorpayment === true || menucheck=== true || menutransfer=== true ||
                        menudebtNote===true || menudebtNoteReconciliation===true || menuvoucherpayment === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Accounts Payable
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menuvendor === true">
                    <li id="vendorLink">
                      <router-link v-bind:to="{ path:'/vendor/list'}" class='removeActive'>
                        <!-- <span class="fa-stack fa-lg pull-left"><i class="hi-icon fp-iconVendors"> </i></span> -->
                        Vendors
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menubill === true">
                    <li id="billLink">
                      <router-link v-bind:to="{ path:'/vendor-invoice/list'}" href="/vendor-invoice/list">
                        Vendor Invoices
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menucreditnote === true">
                    <li id="creditNoteLink">
                      <router-link v-bind:to="{ path:'/credit-note/list'}" href="/credit-note/list">
                        Credit/Debit Notes
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuvendorpayment === true">
                    <li id="vendorPaymentLink">
                      <router-link v-bind:to="{ path:'/vendor-payment/list'}" href="/vendor-payment/list">
                        Payments
                      </router-link>
                    </li>
                  </template>
                  <template>
                    <li id="checkLink" v-if="menucheck=== true">
                      <router-link v-bind:to="{ path:'/check/list'}" href="/check/list">
                        Checks
                      </router-link>
                    </li>
                  </template>

                  <template v-if="menudebtNote=== true">
                    <li id="debtNoteList">
                      <router-link v-bind:to="{ path:'/debtnote/list'}" href="/debtnote/list">
                        Debt Notes
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menudebtNoteReconciliation=== true">
                    <li id="debtPaymentReconciliation">
                      <router-link v-bind:to="{ path:'/debtpayment/reconciliation'}" href="/debtpayment/reconciliation">
                        Debt Payment Reconciliation
                      </router-link>
                    </li>
                  </template>
                  <template>
                    <li id="voucherPaymentMaintenanceLink" v-if="menuvoucherpayment=== true">
                      <router-link v-bind:to="{ path:'/voucher-payment/maintenance/list'}"
                                   href="/voucher-payment/maintenance/list">
                        Voucher Payment Maintenance
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
              <template v-if="menudepreciation === true">
                <li id="depreciationLink">
                  <router-link v-bind:to="{ path:'/depreciation-schedule/list'}" href="/depreciation-schedule/list">
                    Depreciation Schedule
                  </router-link>
                </li>
              </template>
              <template>
                <li id="bankTransferLink" v-if="menutransfer=== true">
                  <router-link v-bind:to="{ path:'/bank-transfer/list'}" href="/bank-transfer/list">
                    Bank Reconciliation
                  </router-link>
                </li>
              </template>
              <template>
                <li id="bankSummaryLink" v-if="menutransfer=== true">
                  <router-link v-bind:to="{ path:'/bank-summary/view'}" href="/bank-summary/view">
                    Bank Summary
                  </router-link>
                </li>
              </template>
              <template>
                <li id="glBalanceLink" v-if="menuGLBalance=== true">
                  <router-link v-bind:to="{ path:'/gl-balances'}" href="/gl-balances">
                    GL Inquiry
                  </router-link>
                </li>
              </template>
              <li id="accountGlLink"
                  v-if="menuglaccount=== true || menujournal=== true || menuglreport=== true || menuwrongglreport === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    GL Account
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menuglaccount=== true">
                    <li id="glaccountLink">
                      <router-link v-bind:to="{ path:'/gl-account/list'}" href="/gl-account/list">
                        GL Accounts
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuglaccount=== true">
                    <li id="glaccountLink">
                      <router-link v-bind:to="{ path:'/charge-account/list'}" href="/charge-account/list">
                        Charge
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menujournal=== true">
                    <li id="journalLink">
                      <router-link v-bind:to="{ path:'/journal/list'}" href="/journal/list">
                        Journals
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menujournal=== true">
                    <li id="journalRecurringLink">
                      <router-link v-bind:to="{ path:'/journal-recurring/list'}" href="/journal-recurring/list">
                        Recurring Journals Entries
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuglreport=== true">
                    <li id="generalLedgerLink">
                      <router-link v-bind:to="{ path:'/report/general-ledger'}" href="/report/general-ledger">
                        General Ledger
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuglreport=== true">
                    <li id="billingReversingJournalEntry">
                      <router-link v-bind:to="{ path:'/billing-reversing-journal-entry'}"
                                   href="/billing-reversing-journal-entry">
                        Billing Reversing Journal Entry
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuwrongglreport=== true">
                    <li id="wrongGlAccountsLink">
                      <router-link v-bind:to="{ path:'/gl-transaction/list'}" href="/gl-transaction/list">
                        Wrong GL List
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
              <!-- <li id="accountingReportsLink" v-if="menuglreport=== true">
                            <label class="tree-toggle nav-header">
                                <a href="javascript:void(0)">
                                    Reports
                                    <i aria-hidden="true" class="fp-down-arrow"></i>
                                </a>
                            </label>
                            <ul class="nav tree dr-tree">

                                <template v-if="menutaxsummaryreport=== true">
                                    <li id="taxSummaryLink">
                                        <router-link v-bind:to="{ path:'/report/tax-summary'}" href="/report/tax-summary">
                                            Tax Summary
                                        </router-link>
                                    </li>
                                </template>
                                <template v-if="menuincomesummaryreport=== true">
                                    <li id="incomeSummaryLink">
                                        <router-link v-bind:to="{ path:'/report/income-summary'}" href="/report/income-summary">
                                            Income Summary
                                        </router-link>
                                    </li>
                                </template>
                                <template v-if="menuexpensesummaryreport=== true">
                                    <li id="expenseSummaryLink">
                                        <router-link v-bind:to="{ path:'/report/expense-summary'}" href="/report/expense-summary">
                                            Expense Summary
                                        </router-link>
                                    </li>
                                </template>
                                <template v-if="menuprofitlossreport=== true">
                                    <li id="profitLossLink">
                                        <router-link v-bind:to="{ path:'/report/profit-loss'}" href="/report/profit-loss">
                                            Profit And Loss
                                        </router-link>
                                    </li>
                                </template>
                                <template v-if="menutrialbalance=== true">
                                    <li id="trialBalanceLink">
                                        <router-link v-bind:to="{ path:'/report/trial-balance'}" href="/report/trial-balance">
                                            Trial Balance
                                        </router-link>
                                    </li>
                                </template>

                            </ul>
                        </li> -->
              <template>
                <li id="subSystemLink" v-if="menusubsystem=== true">
                  <router-link v-bind:to="{ path:'/sub-system/list'}" href="/sub-system/list">
                    Close Subsystem
                  </router-link>
                </li>
              </template>
            </ul>
          </li>

          <!-- <li id="reportTabLink" v-if="menucustomerloginreport === true || menucustomerregisterreport === true || menucustomerinteractionreport === true
                        || menupotentialcancellationreport===true || menurentalcancellationreport === true || menemailreport === true || rentalutilizeasset===true
                        || menucustomer===true || menucustomercontact===true  || menuinsurancepolicy === true
                        || menuglreport=== true || menucontract === true ||  menufuelticket === true ||  menuinvoice === true  || menuscoperate === true || menuitemrental === true ||
                        menushiftdetail === true || menuvehiclepermit === true || menudepreciation === true || comptransaction === true || menuitemrental === true || menurentalagreement === true || menuagedtrialbalsummary === true
                        || menuagedtrialbaldetail === true || menunotepadreview === true || menuagedtrialbaldetailgrid === true || menuappaymentupload === true || menuaptrialbalancedetailasat === true || menuapvoucherdistribution === true || menuarreceiptandapplication === true
                        || menuwoaccounttransaction === true || menuopenonaccountcash === true || menultdunitprofitloss === true">
                    <label class="tree-toggle nav-header">
                        <a href="javascript:void(0)">
                            <i class="fp-reports"> </i>
                            Reports
                            <i aria-hidden="true" class="fp-down-arrow"></i>
                        </a>
                    </label>
                    <ul class="nav tree">
                        <template v-if="menucustomer === true">
                            <li id="customerReportLink">
                                <router-link v-bind:to="{ path:'/customer-report/list'}" href="/customer-report/list" >
                                    Customers Listing
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menucustomercontact === true">
                            <li id="customercontactReportLink">
                                <router-link v-bind:to="{ path:'/customer-contact-report/list' , query: { flag : 'contactReport' }}" href="/customer-contact-report/list?flag=contactReport">
                                    Customer Contacts
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuinsurancepolicy === true">
                            <li id="insurancePolicyReportLink">
                                <router-link v-bind:to="{ path:'/insurance-policy-report/list'}" href="/insurance-policy-report/list">
                                    Insurance Policies
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuglreport=== true">
                            <li id="generalLedgerReportLink">
                                <router-link v-bind:to="{ path:'/gl-detail-report/list'}" href="/gl-detail-report/list" >
                                    General Ledger Details
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menucontract === true">
                            <li id="contractReportLink">
                                <router-link v-bind:to="{ path:'/lease-contract-report/list'}" href="/lease-contract-report/list" class='removeActive'>
                                Lease Contracts
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menufuelticket === true">
                            <li id="fuelTicketReportLink" >
                                <router-link v-bind:to="{ path:'/fuel-ticket-report/list'}" href="/fuel-ticket-report/list">
                                    Fuel Ticket Detail
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menucustomer === true">
                            <li id="vehicleReportLink">
                                <router-link v-bind:to="{ path:'/equipment-master/list', query: { flag : 'assetReport' } }" href="/equipment-master/list?flag=assetReport">
                                    Equipment Master
                                </router-link>
                            </li>
                        </template>
                        <template>
                            <li id="vehicleFeatureReportLink">
                                <router-link v-bind:to="{ path:'/asset-feature/list'}" href="/asset-feature/list">
                                    Equipment Feature
                                </router-link>
                            </li>
                        </template>
                         <template v-if="menuinvoice === true">

                            <li id="invoiceReportLink">
                                <router-link v-bind:to="{ path:'/invoice-disposal-report/list' , query: { flag : 'disposal' }}" href="/invoice-disposal-report/list?flag=disposal" >
                                    Disposal Invoice Listing
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuinvoice === true">
                            <li id="invoiceReportLink">
                                <router-link v-bind:to="{ path:'/invoice-disposal-report/list' }" href="/invoice-disposal-report/list" >
                                    Disposal Invoice Listing
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuinvoice === true">

                            <li id="invoiceListReportLink">
                                <router-link v-bind:to="{ path:'/invoice-report/list' }" href="/invoice-report/list" >
                                    Invoice Listing
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menurentalagreement === true">

                            <li id="rentalListReportLink">
                                <router-link v-bind:to="{ path:'/rental-report/list'}" href="/rental-report/list" >
                                    Rental Listing
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuscoperate === true">
                            <li id="scoperateReportLink">
                                <router-link v-bind:to="{ path:'/customer-rental-scoperate-report/list'}" href="/customer-rental-scoperate-report/list">
                                    Customer Rental Scope Rates
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuitemrental === true">
                            <li id="availableEquipmentReportLink">
                                <router-link v-bind:to="{ path:'/available-equipment-report/list'}" href="/available-equipment-report/list">
                                    Available Equipment
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuitemrental === true">
                            <li id="reservationReportLink">
                                <router-link v-bind:to="{ path:'/reservation-report/list'}" href="/reservation-report/list">
                                    Reservation Listing
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menushiftdetail === true">
                            <li id="gangsheetReportLink">
                                <router-link v-bind:to="{ path:'/gangsheet-report/list'}" href="/gangsheet-report/list">
                                    Gangsheet Details
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuvehiclepermit === true">
                            <li id="permitReportLink">
                                <router-link v-bind:to="{ path:'/permit-entry-report/list'}" href="/permit-entry-report/list">
                                    Permit in Entry Status
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuvehiclepermit === true">
                            <li id="unitPermitReportLink">
                                <router-link v-bind:to="{ path:'/unit-permit-report/list'}" href="/unit-permit-report/list">
                                    Unit Permit Detail
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menudepreciation === true">
                            <li id="depreciationReportLink">
                                <router-link v-bind:to="{ path:'/depreciation-review-report/list'}" href="/depreciation-review-report/list">
                                    Depreciation Review
                                </router-link>
                            </li>
                        </template>
                        <template v-if="comptransaction === true">
                            <li id="inventoryReportLink">
                                <router-link v-bind:to="{ path:'/inventory-report/list'}" href="/inventory-report/list">
                                    Inventory As At Detail
                                </router-link>
                            </li>
                        </template>
                         <template v-if="menuitemrental === true">
                            <li id="weeklyRentalReportLink">
                                <router-link v-bind:to="{ path:'/weekly-rental-report/list' }" href="/weekly-rental-report/list">
                                    Weekly Rental Report
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuitemrental === true">
                            <li id="equipmentPoolReportLink">
                                <router-link v-bind:to="{ path:'/equipment-pool-report/list' }" href="/equipment-pool-report/list">
                                    Equipment Pool Transfer
                                </router-link>
                            </li>
                        </template>
                         <template v-if="menucustomer === true">
                            <li id="ownedEquipmentReportLink">
                                <router-link v-bind:to="{ path:'/owned-equipment-report/list' }" href="/owned-equipment-report/list">
                                    Owned Equipment Current Values
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuVechicle === true">
                            <li id="equipmentCurrentStatusReportLink">
                                <router-link v-bind:to="{ path:'/equipment-current-status-report/list' }" href="/equipment-current-status-report/list">
                                    Equipment Current Status
                                </router-link>
                            </li>
                        </template>

                        <template v-if="menuschedulereport === true">
                            <li id="schedulereportLink">
                                <router-link v-bind:to="{ path:'/schedule-report/list'}" class='removeActive'>
                                    Schedule Reports
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menucustomerloginreport === true">
                            <li id="customerLoginReportLink">
                                <router-link v-bind:to="{ path:'/report/customer-login'}" href="/report/customer-login">
                                    Customer Login
                                </router-link>
                            </li>
                        </template>
                        <template  v-if="menucustomerregisterreport === true" >
                            <li id="customerRegisterReportLink">
                                <router-link v-bind:to="{ path:'/report/customer-register'}" href="/report/customer-register">
                                    Customer Register
                                </router-link>
                            </li>
                        </template>
                         <template v-if="menucustomerinteractionreport === true" >
                            <li id="customerInteractionReportLink">
                                <router-link v-bind:to="{ path:'/report/customer-interaction'}" href="/report/customer-interaction">
                                    Customer Interaction
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menupotentialcancellationreport === true">
                            <li id="potentialCancellationLink">
                                <router-link v-bind:to="{ path:'/report/potential-cancellation'}" href="/report/potential-cancellation">
                                    Potential Cancellation
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menurentalcancellationreport === true">
                            <li id="rentalCancellationLink">
                                <router-link v-bind:to="{ path:'/report/rental-cancellation'}" href="/report/rental-cancellation">
                                    Rental Cancellation
                                </router-link>
                            </li>
                        </template>

                        <template v-if="menemailreport === true">
                            <li id="mailReportLink">
                                <router-link v-bind:to="{ path:'/report/emails'}" href="/report/emails">
                                    Emails Report
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuoverdue === true">
                            <li id="menuoverdueLink">
                                <router-link v-bind:to="{ path:'/available-overdue-asset/list'}" href="/available-overdue-asset/list">
                                    Available & Overdue Asset
                                </router-link>
                            </li>
                        </template>
                        <template v-if="rentalutilizeasset === true">
                            <li id="utilizeAssetReportLink">
                                <router-link v-bind:to="{ path:'/report/utilize-asset'}" href="/report/utilize-asset">
                                    Rental Utilization Equipment
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuchargecodeaccount === true">
                            <li id="chargeCodeAccountLink">
                                <router-link v-bind:to="{ path:'/charge-code-account/list'}" href="/charge-code-account/list">
                                    Charge Code Account
                                </router-link>
                            </li>
                        </template>
                        <template>
                            <li id="rentalActivityLink">
                                <router-link v-bind:to="{ path:'/rental-activity-report/list'}" href="/rental-activity-report/list">
                                    Rental Activity Report
                                </router-link>
                            </li>
                        </template>
                        <template>
                            <li id="substituteLink">
                                <router-link v-bind:to="{ path:'/substitute-unit-report/list'}" href="/rsubstitute-unit-report/list">
                                    Sub Day In Period
                                </router-link>
                            </li>
                        </template>
                        <template>
                            <li id="currentInsuranceLink">
                                <router-link v-bind:to="{ path:'/current-insurance-policy-report/list'}" href="/current-insurance-policy-report/list">
                                    Lease Rental Current Insurance Policy Review
                                </router-link>
                            </li>
                        </template>
                        <template>
                            <li id="PMUnitDetailLink">
                                <router-link v-bind:to="{ path:'/pm-unit-detail-report/list'}" href="/pm-unit-detail-report/list">
                                    PM Unit Detail With History
                                </router-link>
                            </li>
                        </template>
                        <template>
                            <li id="PMUnitForecastLink">
                                <router-link v-bind:to="{ path:'/pm-unit-forecast-report/list'}" href="/pm-unit-forecast-report/list">
                                    PM Unit Forecast
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuagedtrialbalsummary=== true">
                            <li id="agedTrialBalSummaryLink">
                                <router-link v-bind:to="{ path:'/report/customer-aged-trial-balance-summary'}" href="/report/customer-aged-trial-balance-summary">
                                    Customer Aged Trial Balance Summary
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuagedtrialbaldetail=== true">
                            <li id="agedTrialBalDetailLink">
                                <router-link v-bind:to="{ path:'/report/aged-trial-balance-detail'}" href="/report/aged-trial-balance-detail">
                                    Aged Trial Balance Detail As At
                                </router-link>
                            </li>
                        </template>
                        <template>
                            <li id="billingReadingForPeriod">
                                <router-link v-bind:to="{ path:'/billing-reading-for-period-report/list'}" href="/billing-reading-for-period-report/list">
                                    Billing Reading For Period
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menunotepadreview=== true">
                            <li id="notePadReviewLink">
                                <router-link v-bind:to="{ path:'/report/note-pad-review'}" href="/report/note-pad-review">
                                    Note Pad Review
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuagedtrialbaldetailgrid=== true">
                            <li id="agedTrialBalanceDetailGridLink">
                                <router-link v-bind:to="{ path:'/report/aged-trial-balance-detail-grid'}" href="/report/aged-trial-balance-detail-grid">
                                    Aged Trial Balance Detail Grid
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuappaymentupload=== true">
                            <li id="apPaymentUploadLink">
                                <router-link v-bind:to="{ path:'/report/ap-payment-upload'}" href="/report/ap-payment-upload">
                                    AP Payment Upload / Outstanding AP
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuaptrialbalancedetailasat=== true">
                            <li id="apTrialBalanceAsAtDetailLink">
                                <router-link v-bind:to="{ path:'/report/ap-trial-balance-as-at-detail'}" href="/report/ap-trial-balance-as-at-detail">
                                    AP Trial Balance As At Detail
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuapvoucherdistribution=== true">
                            <li id="apVoucherDistributionLink">
                                <router-link v-bind:to="{ path:'/report/ap-voucher-distribution-edit'}" href="/report/ap-voucher-distribution-edit">
                                    AP Voucher Distribution Edit
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuarreceiptandapplication=== true">
                            <li id="arReceiptAndApplicationLink">
                                <router-link v-bind:to="{ path:'/report/ar-receipt-and-application'}" href="/report/ar-receipt-and-application">
                                    AR Receipts And Applications
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuwoaccounttransaction=== true">
                            <li id="woAccountingTransactionLink">
                                <router-link v-bind:to="{ path:'/report/work-order-accounting-transaction'}" href="/report/work-order-accounting-transaction">
                                    Work Order Accounting Transactions
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menuopenonaccountcash=== true">
                            <li id="openOnAccountCashLink">
                                <router-link v-bind:to="{ path:'/report/open-on-account-cash'}" href="/report/open-on-account-cash">
                                    Open On Account Cash
                                </router-link>
                            </li>
                        </template>
                        <template v-if="menultdunitprofitloss=== true">
                            <li id="unitProfitLossSummaryLink">
                                <router-link v-bind:to="{ path:'/report/ltd-unit-profit-loss-summary'}" href="/report/ltd-unit-profit-loss-summary">
                                    LTD Unit Profit And Loss Summary
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </li> -->
          <template v-if="menunotes === true">
            <li id="notesLink">
              <router-link v-bind:to="{ path:'/notes/list'}" href="/notes/list">
                <i class="fp-accounting"> </i>
                Notes
              </router-link>
            </li>
          </template>
          <template>
            <li id="batchLink">
              <router-link v-bind:to="{ path:'/batch/list'}" href="/batch/list">
                <i class="fp-batch"> </i>
                Batch
              </router-link>
            </li>
          </template>
          <template v-if="menemailreport === true">
            <li id="mailReportLink">
              <router-link v-bind:to="{ path:'/report/emails'}" href="/report/emails">
                <i class="fp-reports"> </i>
                Emails Report
              </router-link>
            </li>
          </template>
<!--          <template v-if="menucrm=== true">-->
<!--            <li id="crmLink">-->
<!--              <router-link v-bind:to="{ path:'/crm/list'}" href="/crm/list">-->
<!--                <i class="fp-agreement"> </i>-->
<!--                CRM-->
<!--              </router-link>-->
<!--            </li>-->
<!--          </template>-->

          <template v-if="menuactivitylog === true">
            <li id="activityLink">
              <router-link v-bind:to="{ path:'/activitylog/list'}" class='removeActive'>
                <i class="fp-log-file-format"> </i>
                Activity Logs
              </router-link>
            </li>
          </template>

          <!-- <template v-if="menuVechicle === true">
                    <li id="vehicleLink">
                        <router-link v-bind:to="{ path:'/asset/list'}" class='removeActive'>
                            <span class="fa-stack fa-lg pull-left"> <i class="hi-icon fp-iconTruck-asset"> </i> </span>
                            Assets
                        </router-link>
                    </li>
                </template> -->

          <!-- <li id="importDLink" v-if="menuimportdata === true">
                    <label class="tree-toggle nav-header">
                        <a href="javascript:void(0)">
                            <i class="fp-contracts"> </i>
                            Import Data
                            <i aria-hidden="true" class="fp-down-arrow"></i>
                        </a>
                    </label>
                    <ul class="nav tree">
                        <template>
                            <li id="importDataLink">
                                <router-link v-bind:to="{ path:'/import-data'}" class='removeActive'>
                                    Data
                                </router-link>
                            </li>
                        </template>
                        <template>
                            <li id="menuimportdatareview">
                                <router-link v-bind:to="{ path:'/importdatareview/list'}" class='removeActive'>
                                    Data Review
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </li> -->

          <template v-if="menuuser === true">
            <li id="userLink">
              <router-link v-bind:to="{ path:'/user/list'}" class='removeActive'>
                <i class="fp-user"> </i>
                Users
              </router-link>
            </li>
          </template>

          <template v-if="menuenquiry === true">
            <li id="enquiryLink">
              <router-link v-bind:to="{ path:'/inquiry/list'}" href="/inquiry/list">
                <i class="fp-enquiries"> </i>
                Inquiries
              </router-link>
            </li>
          </template>

          <li id="needsLink" v-if="menucustomerneed === true">
            <router-link v-bind:to="{ path:'/customerneeds'}" href="/customerneeds">
              <i class="fp-customer-needs"> </i>
              <!-- <span class="fa-stack fa-lg pull-left"> <i class="hi-icon icon-rtenquiries"></i></span> -->
              Customer Needs
            </router-link>
          </li>

          <!-- <template v-if="menucpiacknowledgementmailsent === true && enToken">
                    <li id="cpiacknowledgementmailsentLink">
                        <router-link v-bind:to="{ path:'/cpiacknowledgementmailsent/list'}" href="/cpiacknowledgementmailsent/list" class='removeActive'>
                            <span class="fa-stack fa-lg pull-left"> <i class="hi-icon fp-iconAcknowledgement"> </i> </span>
                            CPI Acknowledgement
                        </router-link>
                    </li>
                </template> -->


          <li id="odometerlistlink" v-if="menuunitreading===true">
            <router-link v-bind:to="{ path:'/telematics-reading/list'}" href="/telematics-reading/list">
              <i class="fp-agreement"> </i>
              Telematics
            </router-link>
          </li>

          <li id="mileageUploadLink" v-if="menumileageupload===true">
            <router-link v-bind:to="{ path:'/mileage-upload/list'}" href="/mileage-upload/list">
              <i class="fp-agreement"> </i>
              Mileage Upload
            </router-link>
          </li>

          <li id="feedbackLink" v-if="feedback === true">
            <router-link v-bind:to="{ path:'/issues-reported/list'}" href="/issues-reported/list">
              <i class="fp-rental-truck"> </i>
              Feedback
            </router-link>
          </li>

          <template v-if="menuassetinventory === true">
            <li id="inventory">
              <router-link v-bind:to="{ path:'/asset-inventory/list'}" href="/asset-inventory/list">
                <i class="fp-rental-truck"> </i>
                Used Trucks
              </router-link>
            </li>
          </template>
          <template v-if="jobinfo=== true">
            <li id="jobPostingLink">
              <router-link v-bind:to="{ path:'/job-posting/list'}" href="/job-posting/list">
                <i class="fp-customer"></i>
                Post Job
              </router-link>
            </li>
          </template>
          <template v-if="transportrequest === true">
            <li id="transportRequestLink">
              <router-link v-bind:to="{ path:'/transportrequest/list'}" href="/transportrequest/list">
                <i class="fp-transport-request-form"> </i>
                Transfers
              </router-link>
            </li>
          </template>
          <template v-if="travelrequest === true">
            <li id="travelRequestLink">
              <router-link v-bind:to="{ path:'/travelrequest'}" href="/travelrequest">
                <i class="fp-transport-request-form"> </i>
                Travel Form
              </router-link>
            </li>
          </template>


          <!-- Setting links -->
          <li id="settingLink" v-if="menucontracttype === true
                        || menuvehiclemanufacturer===true || menuvehiclemodel===true
                        || menuvehicleownership===true || menuvehiclepool === true || menuassetfeaturecategory===true || menuassetfeature===true
                        || menuitemManufacturer===true || menuitemcategories===true || menuwarehouse===true
                        || menugroup === true || menuextracharges === true || menucharges===true || menurole === true
                        || menugrantpermission === true || menushop === true || menumeasurementunit === true || menulocation === true || menurepresentative === true || menucpicode === true || menueffectivecpirate === true
                        || menucustomerclass === true || menuterm === true || menumetrictype === true || menustandarddefact=== true
                        || damageCode=== true || menuchecklistaction=== true || faqadd=== true || companyinfo=== true || newsinfo=== true || subjectList=== true">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-settings"> </i>
                Settings
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <!-- Contract sub modules -->
              <li id="settingContractLink" v-if="menucontracttype === true ||  menucontractbillingmethod === true
                        || menucpicode === true || menueffectivecpirate === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Contracts
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menucontracttype === true">
                    <li id="contracttypeLink">
                      <router-link v-bind:to="{ path:'/contracttype/list'}" href="/contracttype/list">
                        Contract Type
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menucpicode === true">
                    <li id="cpicodeLink">
                      <router-link v-bind:to="{ path:'/cpicode/list'}" href="/cpicode/list">
                        Cpi Codes
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menueffectivecpirate === true">
                    <li id="effectivecpirateLink">
                      <router-link v-bind:to="{ path:'/effectivecpirate/list'}" href="/effectivecpirate/list">
                        Effective CPI Rate
                      </router-link>
                    </li>
                  </template>
                  <!-- <template v-if="menucpiproofreview === true">
                                    <li id="cpiproofreviewLink">
                                        <router-link v-bind:to="{ path:'/cpiproofreview/list'}" href="/cpiproofreview/list">
                                            CPI Proof Review
                                        </router-link>
                                    </li>
                                </template> -->
                  <!-- <template v-if="menucontractbillingmethod === true">
                                    <li id="contractbillingmethodLink">
                                        <router-link v-bind:to="{ path:'/contractbillingmethod/list'}" href="/contractbillingmethod/list">
                                            Billing Method
                                        </router-link>
                                    </li>
                                </template> -->
                  <!--<template v-if="menucontractbillingfrequency === true">
                                    <li id="contractbillingfrequencyLink">
                                        <router-link v-bind:to="{ path:'/contractbillingfrequency/list'}" href="/contractbillingfrequency/list">
                                            Billing Frequency
                                        </router-link>
                                    </li>
                                </template>-->
                  <!-- <template v-if="menucontracttypesectionmapper === true">
                                    <li id="contracttypesectionmapperLink">
                                        <router-link v-bind:to="{ path:'/contracttypesectionmapper/list'}" href="/contracttypesectionmapper/list">
                                            Contract Type Section Mapper
                                        </router-link>
                                    </li>
                                </template> -->
                </ul>
              </li>
              <!-- Assets sub modules -->
              <li id="settingAssetsLink" v-if="menuvehiclemanufacturer === true || menuvehiclemodel === true
                            || menuvehicleownership==true || menuvehiclepool === true || menuvehiclepermittype === true || menuassetfeaturecategory === true
                            || menuassetfeaturecategory===true || menufeature===true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Assets
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <!-- <template v-if="menuvehiclestatus === true">
                                    <li id="vehicleStatusLink">
                                        <router-link v-bind:to="{ path:'/assetstatuses/list'}" href="/assetstatuses/list">
                                            Statuses
                                        </router-link>
                                    </li>
                                </template> -->
                  <!-- <template v-if="menuassetfeaturecategory === true">
                                    <li id="assetfeaturecategory">
                                        <router-link v-bind:to="{ path:'/assetfeaturecategory/list'}" href="/assetfeaturecategory/list">
                                            Feature Category
                                        </router-link>
                                    </li>
                                </template> -->
                  <template v-if="menufeature === true">
                    <li id="assetfeatures">
                      <router-link v-bind:to="{ path:'/feature/list'}" href="/feature/list">
                        Features
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuvehiclemanufacturer === true">
                    <li id="vehicleManufacturerLink">
                      <router-link v-bind:to="{ path:'/assetmanufacturer/list'}" href="/assetmanufacturer/list">
                        Manufacturers
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuvehiclemodel === true">
                    <li id="vehicleModelLink">
                      <router-link v-bind:to="{ path:'/assetmodel/list'}" href="/assetmodel/list">
                        Models
                      </router-link>
                    </li>
                  </template>
                  <!-- <template v-if="menuvehicleownership === true">
                                    <li id="vehicleOwnershipLink">
                                        <router-link v-bind:to="{ path:'/assetownership/list'}" href="/assetownership/list">
                                            Ownerships
                                        </router-link>
                                    </li>
                                </template> -->

                  <template v-if="menuvehiclepool === true">
                    <li id="vehiclePoolLink">
                      <router-link v-bind:to="{ path:'/assetpool/list'}" href="/assetpool/list">
                        Pools
                      </router-link>
                    </li>
                  </template>

                  <!-- <template v-if="menuassetstandardfeature === true">
                                    <li id="assetstandardfeatures">
                                        <router-link v-bind:to="{ path:'/assetstandardfeature/list'}" href="/assetstandardfeature/list">
                                            Standard Feature Configurations
                                        </router-link>
                                    </li>
                                </template> -->

                </ul>
              </li>
              <template v-if="subjectList === true">
                <li id="subjectList">
                  <router-link v-bind:to="{ path:'/subject/list'}" href="/subject/list">
                    Subject
                  </router-link>
                </li>
              </template>
              <template v-if="menugroup === true">
                <li id="groupLink">
                  <router-link v-bind:to="{ path:'/group/list'}" href="/group/list">
                    Groups
                  </router-link>
                </li>
              </template>

              <template v-if="menugroup === true">
                <li id="groupLink">
                  <router-link v-bind:to="{ path:'/gl-account-configuration/list'}"
                               href="/gl-account-configuration/list">
                    GL Account Configuration
                  </router-link>
                </li>
              </template>


              <li id="extrachargelink" v-if="menuextracharges">
                <router-link v-bind:to="{ path:'/extra-charge/list'}" href="/extra-charge/list" class='removeActive'>
                  Extra Charges
                </router-link>
              </li>
              <li id="chargelink" v-if="menucharges">
                <router-link v-bind:to="{ path:'/charge/list'}" href="/charge/list" class='removeActive'>
                  Charges
                </router-link>
              </li>
              <li id="taxlink" v-if="menucharges">
                <router-link v-bind:to="{ path:'/tax/list'}" href="/tax/list" class='removeActive'>
                  Taxes
                </router-link>
              </li>


              <template v-if="menurole === true">
                <li id="roleLink">
                  <router-link v-bind:to="{ path:'/roles/list'}" href="/roles/list">
                    Roles
                  </router-link>
                </li>
              </template>
              <template v-if="menugrantpermission === true">
                <li id="grantPermissionLink">
                  <router-link v-bind:to="{ path:'/grantpermission'}" href="/grantpermission">
                    Grant Permissions
                  </router-link>
                </li>
              </template>
              <template v-if="menushop === true">
                <li id="shopLink">
                  <router-link v-bind:to="{ path:'/shops/list'}" href="/shops/list">
                    Shops
                  </router-link>
                </li>
              </template>
              <template v-if="menumeasurementunit === true">
                <li id="measurementUnitLink">
                  <router-link v-bind:to="{ path:'/measurementunit/list'}" href="/measurementunit/list">
                    Measurement Units
                  </router-link>
                </li>
              </template>

              <template v-if="menulocation === true">
                <li id="locationLink">
                  <router-link v-bind:to="{ path:'/location/list'}" href="/location/list">
                    Locations
                  </router-link>
                </li>
              </template>
              <template v-if="menurepresentative === true">
                <li id="representativeLink">
                  <router-link v-bind:to="{ path:'/representative/list'}" href="/representative/list">
                    Representative
                  </router-link>
                </li>
              </template>

              <template v-if="menucustomerclass === true">
                <li id="customerclassLink">
                  <router-link v-bind:to="{ path:'/customerclass/list'}" href="/customerclass/list">
                    Customer Classes
                  </router-link>
                </li>
              </template>

              <template v-if="menuterm === true">
                <li id="termLink">
                  <router-link v-bind:to="{ path:'/term/list'}" href="/term/list">
                    Terms
                  </router-link>
                </li>
              </template>

              <template v-if="menumetrictype === true">
                <li id="metrictypeLink">
                  <router-link v-bind:to="{ path:'/metrictype/list'}" href="/metrictype/list">
                    Metric Type
                  </router-link>
                </li>
              </template>

              <template v-if="menustandarddefact=== true">
                <li id="standarddefectLink">
                  <router-link v-bind:to="{ path:'/standard-defect/list'}" href="/standard-defect/list">
                    Standard Defects
                  </router-link>
                </li>
              </template>

              <template v-if="damageCode=== true">
                <li id="reasonLink">
                  <router-link v-bind:to="{ path:'/reason/list'}" href="/reason/list">
                    Reasons
                  </router-link>
                </li>
              </template>
              <template v-if="menuchecklistaction=== true">
                <li id="checklistactionLink">
                  <router-link v-bind:to="{ path:'/checklist-action/list'}" href="/checklist-action/list">
                    Checklist Action
                  </router-link>
                </li>
              </template>

              <template v-if="faqadd=== true">
                <li id="faq">
                  <router-link v-bind:to="{ path:'/faq/list'}" href="/faq/list">
                    FAQ
                  </router-link>
                </li>
              </template>
              <template>
                <li id="companyInfoLink" v-if="companyinfo=== true">
                  <router-link v-bind:to="{ path:'/company-info'}" href="/company-info">
                    Company Info
                  </router-link>
                </li>
              </template>
              <template>
                <li id="newsLink" v-if="newsinfo=== true">
                  <router-link v-bind:to="{ path:'/news/list'}" href="/news/list">
                    News
                  </router-link>
                </li>
              </template>

              <template>
                <li id="featureMapLink" v-if="newsinfo=== true">
                  <router-link v-bind:to="{ path:'/feature-mapping/create'}" href="/feature-mapping/create">
                    Map Feature
                  </router-link>
                </li>
              </template>
              <!-- <template>
                            <li id="accountSettingLink" v-if="accountsetting=== true">
                                <router-link v-bind:to="{ path:'/account-setting'}" href="/account-setting">
                                    Account Setting
                                </router-link>
                            </li>
                        </template> -->
              <template>
                <li id="systemParamLink" v-if="systemParam=== true">
                  <router-link v-bind:to="{ path:'/system-param/list'}" href="/system-param/list">
                    System Param
                  </router-link>
                </li>
              </template>

              <template>
                <li id="showJobs" v-if="showJobs === true">
                  <router-link v-bind:to="{ path:'/jobs/list'}" href="/jobs/list">
                    Jobs
                  </router-link>
                </li>
              </template>
            </ul>
          </li>
        </template>
        <template v-else-if="role !== 'end customer'">

          <!-- <li id="reportTabLink" v-if="menucustomerloginreport === true || menucustomerregisterreport === true || menucustomerinteractionreport === true
                        || menupotentialcancellationreport===true || menurentalcancellationreport === true || menemailreport === true || rentalutilizeasset===true
                        || menucustomer===true || menucustomercontact===true  || menuinsurancepolicy === true
                        || menuglreport=== true || menucontract === true ||  menufuelticket === true ||  menuinvoice === true  || menuscoperate === true || menuitemrental === true ||
                        menushiftdetail === true || menuvehiclepermit === true || menudepreciation === true || comptransaction === true || menuitemrental === true || menurentalagreement === true || menuagedtrialbalsummary === true
                        || menuagedtrialbaldetail === true || menunotepadreview === true">
                    <label class="tree-toggle nav-header">
                        <a href="javascript:void(0)">
                            <i class="fp-reports"> </i>
                            Reports
                            <i aria-hidden="true" class="fp-down-arrow"></i>
                        </a>
                    </label>
                    <ul class="nav tree"> -->
          <li id="assetManagementTabLink" v-if="menudepreciationreview === true || menudepreciationnbv === true|| menuequipmentcurrentstatus === true ||
                       menuequipmentpooltransfer === true ||menuinsurancepolicyreport === true || menuownedequipmentreport === true || menultdunitprofitloss === true || menudisposalinvoice === true || menudebtnotebalance === true ||
                       menudebtnoteunitdetail === true || menudebtnotepostingdetail === true || menudebtnoteschedule === true && role !== 'end customer'">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-truck-asset"> </i>
                Asset Management
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <li id="AMEquipmentReport"
                  v-if="menuequipmentcurrentstatus === true || menuequipmentpooltransfer === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    AM Equipment
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menuequipmentcurrentstatus === true">
                    <li id="equipmentCurrentStatusReportLink">
                      <router-link v-bind:to="{ path:'/equipment-current-status-report/list' }"
                                   href="/equipment-current-status-report/list">
                        Equipment Current Status
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuequipmentpooltransfer === true">
                    <li id="equipmentPoolReportLink">
                      <router-link v-bind:to="{ path:'/equipment-pool-report/list' }"
                                   href="/equipment-pool-report/list">
                        Equipment Pool Transfer
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
              <li id="DebtNoteReportTab"
                  v-if="menudebtnotebalance === true || menudebtnoteunitdetail === true || menudebtnotepostingdetail === true || menudebtnoteschedule === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Debt Note
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menudebtnotebalance === true">
                    <li id="debtNoteBalanceDetail">
                      <router-link v-bind:to="{ path:'/debt-note-balance/list' }" href="/debt-note-balance/list">
                        Debt Note Balance Detail
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menudebtnoteunitdetail === true">
                    <li id="DebtNoteUnitDetailReport">
                      <router-link v-bind:to="{ path:'/debt-note-unit-report/list' }"
                                   href="/debt-note-unit-report/list">
                        Debt Note Unit Detail
                      </router-link>
                    </li>
                  </template>
                  <!-- <template>
                                  <li id="DebtNoteRollForwardReport">
                                      <router-link v-bind:to="{ path:'/debtnote-roll-forward/list' }" href="/debtnote-roll-forward/list">
                                          Debt Note Roll Forward
                                      </router-link>
                                  </li>
                              </template> -->
                  <template v-if="menudebtnotepostingdetail === true">
                    <li id="DebtNotePostingDetail">
                      <router-link v-bind:to="{ path:'/debt-note-posting-detail/list' }"
                                   href="/debt-note-posting-detail/list">
                        Debt Note Posting Detail
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menudebtnoteschedule === true">
                    <li id="DebtNoteSchedule">
                      <router-link v-bind:to="{ path:'/debt-note-schedule/list' }" href="/debt-note-schedule/list">
                        Debt Note Schedule
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
              <li id="depreciationReport" v-if="menudepreciationreview === true || menudepreciationnbv === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Depreciation
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menudepreciationreview=== true">
                    <li id="depreciationReportLink">
                      <router-link v-bind:to="{ path:'/depreciation-review-report/list'}"
                                   href="/depreciation-review-report/list">
                        Depreciation Review
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menudepreciationnbv === true">
                    <li id="depreciationNBVReportLink">
                      <router-link v-bind:to="{ path:'/depreciation-nbv-report/list'}"
                                   href="/depreciation-nbv-report/list">
                        Depreciation NBV As At
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
              <li id="disposalReport" v-if="menudisposalinvoice === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Disposals
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menudisposalinvoice === true">
                    <li id="invoiceReportLink">
                      <router-link v-bind:to="{ path:'/invoice-disposal-report/list' }"
                                   href="/invoice-disposal-report/list">
                        Disposal Invoice Listing
                      </router-link>
                    </li>
                  </template>

                </ul>
              </li>
              <li id="insuranceReport" v-if="menuinsurancepolicyreport === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Insurance
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menuinsurancepolicyreport === true">
                    <li id="insurancePolicyReportLink">
                      <router-link v-bind:to="{ path:'/insurance-policy-report/list'}"
                                   href="/insurance-policy-report/list">
                        Insurance Policies
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
              <li id="revenueExpenseReport" v-if="menultdunitprofitloss === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Revenue and Expense
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menultdunitprofitloss === true">
                    <li id="unitProfitLossSummaryLink">
                      <router-link v-bind:to="{ path:'/report/ltd-unit-profit-loss-summary'}"
                                   href="/report/ltd-unit-profit-loss-summary">
                        LTD Unit Profit And Loss Summary
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
              <template v-if="menuownedequipmentreport === true">
                <li id="ownedEquipmentReportLink">
                  <router-link v-bind:to="{ path:'/owned-equipment-report/list'}" href="/owned-equipment-report/list">
                    Owned Equipment Current Values
                  </router-link>
                </li>
              </template>
            </ul>
          </li>
          <li id="EMMSTabLink"
              v-if="menuequipmentmaster === true || menupmcompliancefacilityreport === true||menupmcompliancepoolreport === true || menupmunitforecastreport === true || menupmunitdetailreport === true || menuoutofservicehistory === true || menuinventorydetailreport === true || menurepairhistoryreport === true || laborManage === true || menuequipmentfeaturereport === true || menugangsheetreport === true || menuVechicle === true  || menuwoaccounttransaction === true">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-truck-asset"> </i>
                EMMS
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <li id="CustomerReport" v-if="menushiftdetail === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Customer
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menucustomerloginreport === true">
                    <li id="customerLoginReportLink">
                      <router-link v-bind:to="{ path:'/report/customer-login'}" href="/report/customer-login">
                        Customer Login
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menucustomerregisterreport === true">
                    <li id="customerRegisterReportLink">
                      <router-link v-bind:to="{ path:'/report/customer-register'}" href="/report/customer-register">
                        Customer Register
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menucustomerinvoiceline === true">
                    <li id="customerInvoiceLineDetail">
                      <router-link v-bind:to="{ path:'/customer-invoice-line/report'}"
                                   href="/customer-invoice-line/report">
                        Customer Invoice Line Detail
                      </router-link>
                    </li>
                  </template>

                </ul>
              </li>

              <li id="EquipmentReport" v-if="menuequipmentfeaturereport === true || menuequipmentmaster === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Equipment
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menuequipmentfeaturereport === true">
                    <li id="vehicleFeatureReportLink">
                      <router-link v-bind:to="{ path:'/asset-feature/list'}" href="/asset-feature/list">
                        Equipment Feature
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuequipmentfeaturereport === true">
                    <li id="vehicleFeatureSysReportLink">
                      <router-link v-bind:to="{ path:'/equipment-feature-report/list'}"
                                   href="/equipment-feature-report/list">
                        Equipment Feature (Sys. Params)
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuequipmentmaster === true">
                    <li id="vehicleReportLink">
                      <router-link v-bind:to="{ path:'/equipment-master/list', query: { flag : 'assetReport' } }"
                                   href="/equipment-master/list?flag=assetReport">
                        Equipment Master
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menucostpermetricreport === true">
                    <li id="costPerMetricReport">
                      <router-link v-bind:to="{ path:'/cost-per-metric-unit/report'}"
                                   href="/cost-per-metric-unit/report">
                        Cost Per Metric By Unit
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
              <li id="ETKReport" v-if="menugangsheetreport === true || laborManage === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    ETK
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menugangsheetreport === true">
                    <li id="gangsheetReportLink">
                      <router-link v-bind:to="{ path:'/gangsheet-report/list'}" href="/gangsheet-report/list">
                        Gangsheet Details
                      </router-link>
                    </li>
                  </template>
                </ul>
                <ul class="nav tree dr-tree">
                  <template v-if="laborManage === true">
                    <li id="laborManageReportLink">
                      <router-link v-bind:to="{ path:'/labor-management-report/list'}"
                                   href="/labor-management-report/list">
                        Labor Management Details (Rpt. Prms)
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
              <li id="MaintenanceReport"
                  v-if="menuoutofservicehistory === true || menurepairhistoryreport === true || menuwoaccounttransaction === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Maintenance
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template>
                    <li id="oosHistoryLink" v-if="menuoutofservicehistory === true">
                      <router-link v-bind:to="{ path:'/out-of-service-history/list'}"
                                   href="/out-of-service-history/list">
                        Out Of Service History
                      </router-link>
                    </li>
                  </template>
                  <template>
                    <li id="oosDetailsLink" v-if="menuoutofservicehistory === true">
                      <router-link v-bind:to="{ path:'/out-of-service-details/list'}"
                                   href="/out-of-service-details/list">
                        Out of Service Details
                      </router-link>
                    </li>
                  </template>
                  <template>
                    <li id="repairReportLink" v-if="menurepairhistoryreport === true">
                      <router-link v-bind:to="{ path:'/repair-history-report/list'}" href="/repair-history-report/list">
                        Repair History
                      </router-link>
                    </li>
                  </template>
                  <template>
                    <li id="woAccountingTransactionLink" v-if="menuwoaccounttransaction === true">
                      <router-link v-bind:to="{ path:'/report/work-order-accounting-transaction'}"
                                   href="/report/work-order-accounting-transaction">
                        Work Order Accounting Transactions
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
              <li id="MaterialReport" v-if="menuinventorydetailreport === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Materials
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menuinventorydetailreport === true">
                    <li id="inventoryReportLink">
                      <router-link v-bind:to="{ path:'/inventory-report/list'}" href="/inventory-report/list">
                        Inventory As At Detail
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
              <li id="PurchasingReport" v-if="menushopporeport === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Purchasing
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template>
                    <li id="PMUnitDetailLink" v-if="menushopporeport === true">
                      <router-link v-bind:to="{ path:'/report/shop-purchase-orders'}"
                                   href="/report/shop-purchase-orders">
                        Shop Purchase Orders
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
              <li id="PMSReport"
                  v-if="menupmunitdetailreport === true || menupmunitforecastreport === true || menupmcompliancefacilityreport === true || menupmcompliancepoolreport === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    PMs
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template>
                    <li id="PMUnitDetailLink" v-if="menupmunitdetailreport === true">
                      <router-link v-bind:to="{ path:'/pm-unit-detail-report/list'}" href="/pm-unit-detail-report/list">
                        PM Unit Detail With History
                      </router-link>
                    </li>
                  </template>
                  <template>
                    <li id="PMUnitForecastLink" v-if="menupmunitforecastreport === true">
                      <router-link v-bind:to="{ path:'/pm-unit-forecast-report/list'}"
                                   href="/pm-unit-forecast-report/list">
                        PM Unit Forecast
                      </router-link>
                    </li>
                  </template>
                  <template>
                    <li id="PMComplianceFacilityLink" v-if="menupmcompliancefacilityreport === true">
                      <router-link v-bind:to="{ path:'/pm-compliance-facility/list'}"
                                   href="/pm-compliance-facility/list">
                        PM Compliance - Facility level
                      </router-link>
                    </li>
                  </template>
                  <template>
                    <li id="PMCompliancePoolLink" v-if="menupmcompliancepoolreport === true">
                      <router-link v-bind:to="{ path:'/pm-compliance-pool/list'}" href="/pm-compliance-pool/list">
                        PM Compliance - Pool level
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
              <li id="warrantyReport" v-if="menuwarrantyclaim === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Warranty
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template>
                    <li id="warrantyClaimReport" v-if="menuwarrantyclaim === true">
                      <router-link v-bind:to="{ path:'/warranty-claim/report'}" href="/warranty-claim/report">
                        Warranty Claim Report
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
            </ul>
          </li>
          <li id="FinancialTabLink"
              v-if="menuglreport === true || menucustomerreport === true || menuinvoicelistreport === true || menuagedtrialbaldetail=== true || menuagedtrialbalsummary=== true || menunotepadreview ===true || menuagedtrialbaldetailgrid === true || menuappaymentupload === true || menuaptrialbalancedetailasat === true || menuapvoucherdistribution === true || menuarreceiptandapplication === true || menuopenonaccountcash === true || menutrialbalance === true || menusubletinprocess === true || menuaccruedliability === true || menufuelinventoryclearingreport === true">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-accounting"> </i>
                Financials
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <li id="AccountReceivableReport"
                  v-if="menucustomerreport === true  || menuinvoicelistreport === true || menuagedtrialbaldetail=== true || menuagedtrialbalsummary=== true || menunotepadreview ===true || menuagedtrialbaldetailgrid === true || menuarreceiptandapplication === true || menuopenonaccountcash === true || menucustomeraroutstanding === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Accounts Receivable
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menuagedtrialbaldetail=== true">
                    <li id="agedTrialBalDetailLink">
                      <router-link v-bind:to="{ path:'/report/aged-trial-balance-detail'}"
                                   href="/report/aged-trial-balance-detail">
                        Aged Trial Balance Detail As At
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuagedtrialbalsummary=== true">
                    <li id="agedTrialBalSummaryLink">
                      <router-link v-bind:to="{ path:'/report/customer-aged-trial-balance-summary'}"
                                   href="/report/customer-aged-trial-balance-summary">
                        Aged Trial Balance - Summary
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuagedtrialbaldetailgrid=== true">
                    <li id="agedTrialBalanceDetailGridLink">
                      <router-link v-bind:to="{ path:'/report/aged-trial-balance-detail-grid'}"
                                   href="/report/aged-trial-balance-detail-grid">
                        Aged Trial Balance Detail Grid
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menucustomeraroutstanding=== true">
                    <li id="customerAROutstandingLink">
                      <router-link v-bind:to="{ path:'/report/customer-ar-outstanding'}"
                                   href="/report/customer-ar-outstanding">
                        Customer AR Outstanding
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menucustomerreport === true">
                    <li id="customerReportLink">
                      <router-link v-bind:to="{ path:'/customer-report/list'}" href="/customer-report/list">
                        Customers Listing
                      </router-link>
                    </li>
                  </template>
                  <template>
                    <li id="customercontactReportLink">
                      <router-link
                        v-bind:to="{ path:'/customer-contact-report/list' , query: { flag : 'contactReport' }}"
                        href="/customer-contact-report/list?flag=contactReport">
                        Customer Contacts
                      </router-link>
                    </li>
                  </template>
                  <template>
                    <li id="customerAddressesReportLink">
                      <router-link v-bind:to="{ path:'/customer-addresses-report/list'}"
                                   href="/customer-addresses-report/list">
                        Customer Addresses
                      </router-link>
                    </li>
                  </template>
                  <template>
                    <li id="customerAddressesDetailsReportLink">
                      <router-link v-bind:to="{ path:'/customer-addresses-details-report/list'}"
                                   href="/customer-addresses-details-report/list">
                        Customer Addresses - Details
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuinvoicelistreport === true">
                    <li id="invoiceListReportLink">
                      <router-link v-bind:to="{ path:'/invoice-report/list' }" href="/invoice-report/list">
                        Invoice Listing
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menunotepadreview=== true">
                    <li id="notePadReviewLink">
                      <router-link v-bind:to="{ path:'/report/note-pad-review'}" href="/report/note-pad-review">
                        Note Pad Review
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuarreceiptandapplication=== true">
                    <li id="arReceiptAndApplicationLink">
                      <router-link v-bind:to="{ path:'/report/ar-receipt-and-application'}"
                                   href="/report/ar-receipt-and-application">
                        AR Receipts And Applications
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuopenonaccountcash=== true">
                    <li id="openOnAccountCashLink">
                      <router-link v-bind:to="{ path:'/report/open-on-account-cash'}"
                                   href="/report/open-on-account-cash">
                        Open On Account Cash
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuinvoiceDetail === true">
                    <li id="invoiceDetailReportLink">
                      <router-link v-bind:to="{ path:'/invoice-detail-report/list' }"
                                   href="/invoice-detail-report/list">
                        Invoice Detail
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
              <li id="GeneralLedgerReport"
                  v-if="menuglreport === true || menutrialbalance === true || menusubletinprocess === true || menuaccruedliability === true || menufuelinventoryclearingreport === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    General Ledger
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menuaccruedliability=== true">
                    <li id="accruedLiabilityLink">
                      <router-link v-bind:to="{ path:'/accrued-liability-report/list'}"
                                   href="/accrued-liability-report/list">
                        Accrued Liability - Core
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuglreport=== true">
                    <li id="generalLedgerReportLink">
                      <router-link v-bind:to="{ path:'/gl-detail-report/list'}" href="/gl-detail-report/list">
                        General Ledger Details
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menutrialbalance=== true">
                    <li id="trialBalanceLink">
                      <router-link v-bind:to="{ path:'/report/trial-balance'}" href="/report/trial-balance">
                        Trial Balance
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menusubletinprocess=== true">
                    <li id="subletInProcessLink">
                      <router-link v-bind:to="{ path:'/sublet-in-process/list'}" href="/sublet-in-process/list">
                        Sublet In Process
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menufuelinventoryclearingreport=== true">
                    <li id="fuelInventoryClearingLink">
                      <router-link v-bind:to="{ path:'/fuel-inventory-clearing-Summary/list'}"
                                   href="/fuel-inventory-clearing-Summary/list">
                        Fuel Inventory Clearing Summary
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
              <li id="AccountPayableReport"
                  v-if="menuappaymentupload === true || menuappositivepaylistingreport === true || menuaptrialbalancedetailasat === true || menuapvoucherdistribution === true || menuvendorpayment === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Accounts Payable
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menuaptrialbalancedetailasat=== true">
                    <li id="apTrialBalanceAsAtDetailLink">
                      <router-link v-bind:to="{ path:'/report/ap-trial-balance-as-at-detail'}"
                                   href="/report/ap-trial-balance-as-at-detail">
                        AP Trial Balance As At Detail
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuapvoucherdistribution=== true">
                    <li id="apVoucherDistributionLink">
                      <router-link v-bind:to="{ path:'/report/ap-voucher-distribution-edit'}"
                                   href="/report/ap-voucher-distribution-edit">
                        AP Voucher Distribution Edit
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuappositivepaylistingreport=== true">
                    <li id="apPositivePayLink">
                      <router-link v-bind:to="{ path:'/report/ap-positive-pay-listing'}"
                                   href="/report/ap-positive-pay-listing">
                        AP Positive Pay Listing
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuvendorpayment === true">
                    <li id="vendorPaymentLink">
                      <router-link v-bind:to="{ path:'/vendor-payment/list?flag=reports'}" href="/vendor-payment/list">
                        AP Payment Listing
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
            </ul>
          </li>
          <li id="FuelBillingTabLink" v-if="menufuelticketdetail === true">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-gasoline-pump"> </i>
                Fuel Billing
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <template v-if="menufuelticketdetail === true">
                <li id="fuelTicketReportLink">
                  <router-link v-bind:to="{ path:'/fuel-ticket-report/list'}" href="/fuel-ticket-report/list">
                    Fuel Ticket Detail (ALL)
                  </router-link>
                </li>
              </template>
            </ul>
          </li>
          <li id="FuelTaxTabLink" v-if="menuunitpermitdetail === true">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-gasoline-pump"> </i>
                Fuel Tax
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <template v-if="menuunitpermitdetail === true">
                <li id="unitPermitReportLink">
                  <router-link v-bind:to="{ path:'/unit-permit-report/list'}" href="/unit-permit-report/list">
                    Unit Permit Detail
                  </router-link>
                </li>
              </template>
            </ul>
            <ul class="nav tree">
              <template v-if="menuhvutunitdetail === true">
                <li id="hvutUnitReportLink">
                  <router-link v-bind:to="{ path:'/hvut-unit-report/list'}" href="/hvut-unit-report/list">
                    HVUT Unit Details
                  </router-link>
                </li>
              </template>
            </ul>
          </li>
          <li id="LeaseRentalTabLink" v-if="menucontract === true || menubillreadingforperiodreport === true || menumetricsbilledreport === true || menunetbillingmetricsforperiod === true || menucontractcustomerreport === true || menucontractequipmentreport === true || menucontractequiputilization === true || menuleasecontractreport === true || menuleasecontractexpiryreport === true || menuleaserentalinsurancereview === true
                                                        || menuavailableequipmentreport === true || menucustomerrentalscoperatereport === true || menureservationreport === true || menurentallistingreport === true || menurentalactivityreport === true || menurentalactivitywithratesreport === true || menusubstituteunitreport === true || menucpiratereport === true">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-rental-truck"> </i>
                Lease Rental
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <li id="actionAuditReport">
                <router-link v-bind:to="{ path:'/audit-log/report'}" href="/audit-log/report">
                  Action Audit File
                </router-link>
              </li>
              <li id="BillingReport"
                  v-if="menubillreadingforperiodreport === true || menumetricsbilledreport === true || menunetbillingmetricsforperiod === true  ">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Billing
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menubillreadingforperiodreport === true">
                    <li id="billingReadingForPeriod">
                      <router-link v-bind:to="{ path:'/billing-reading-for-period-report/list'}"
                                   href="/billing-reading-for-period-report/list">
                        Billing Reading For Period
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menumetricsbilledreport === true">
                    <li id="metricsBilledReportLink">
                      <router-link v-bind:to="{ path:'/metrics-billed-report/list' }"
                                   href="/metrics-billed-report/list">
                        Metrics Billed (Detail)
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menumanualbiiling === true">
                    <li id="metricsBilledReportLink">
                      <router-link v-bind:to="{ path:'/manual-billing/list' }" href="/manual-billing/list">
                        Manual Invoices
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menunetbillingmetricsforperiod === true">
                    <li id="netBillingMetricsForPeriod">
                      <router-link v-bind:to="{ path:'/net-billing-metrics-report/list' }"
                                   href="/net-billing-metrics-report/list">
                        Net Billing Metrics For Period (By Date)
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menucontractrevenuereport === true">
                    <li id="contractRevenueReport">
                      <router-link v-bind:to="{ path:'/contract-revenue-report/list' }"
                                   href="/contract-revenue-report/list">
                        Contract Revenue Detail
                      </router-link>
                    </li>
                  </template>

                </ul>
              </li>
              <li id="ContractReport"
                  v-if="menuleasecontractreport === true || menuleasecontractexpiryreport === true || menucontractcustomerreport === true || menucontractequipmentreport === true || menucontractequiputilization === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Lease Contract
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menuleasecontractreport === true">
                    <li id="contractReportLink">
                      <router-link v-bind:to="{ path:'/lease-contract-report/list'}" href="/lease-contract-report/list"
                                   class='removeActive'>
                        Lease Contracts
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menucontract === true">
                    <li id="metricvscontractmetric">
                      <router-link v-bind:to="{ path:'/actual-contract-metric-report/list'}"
                                   href="/actual-contract-metric-report/list" class='removeActive'>
                        Actual Metrics vs Contract Metrics
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menucontract === true">
                    <li id="annualmetricvscontractmetric">
                      <router-link v-bind:to="{ path:'/annual-actual-contract-metric-report/list'}"
                                   href="/annual-actual-contract-metric-report/list" class='removeActive'>
                        Annual Actual Metrics vs Contract Metrics
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuleasecontractexpiryreport === true">
                    <li id="contractExpiryLink">
                      <router-link v-bind:to="{ path:'/lease-contract-expiry/list'}" href="/lease-contract-expiry/list"
                                   class='removeActive'>
                        Lease Contracts Expiry Report
                      </router-link>
                    </li>
                  </template>
                  <template v-if="totalFleetReport === true">
                    <li id="totalFleetReport">
                      <router-link v-bind:to="{ path:'/customer-total-fleet-report/list'}"
                                   href="/customer-total-fleet-report/list" class='removeActive'>
                        Customer Total Fleet
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuratesandutilizationreport === true">
                    <li id="ratesandutilreport">
                      <router-link v-bind:to="{ path:'/lease-rates-and-utilization/list'}"
                                   href="/lease-rates-and-utilization/list" class='removeActive'>
                        Lease Rates & Utilization
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuratesandutilizationreport === true">
                    <li id="ratesandutilreport">
                      <router-link v-bind:to="{ path:'/lease-revenue-forecast/list'}"
                                   href="/lease-revenue-forecast/list" class='removeActive'>
                        Lease Revenue Forecast Report
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menuleasecontractexpiryreport === true">
                    <li id="contractExpiryNonTemplateLink">
                      <router-link v-bind:to="{ path:'/lease-contract-expiry-non-template/list'}"
                                   href="/lease-contract-expiry-non-template/list" class='removeActive'>
                        Lease Contracts Expiry Non-Template Report
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menucontractcustomerreport === true">
                    <li id="contractCustomerReportLink">
                      <router-link v-bind:to="{ path:'/contract-customer-report/list'}"
                                   href="/contract-customer-report/list" class='removeActive'>
                        Contract Customer List
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menucontractequipmentreport === true">
                    <li id="contractEquipmentReportLink">
                      <router-link v-bind:to="{ path:'/contract-equipment-as-at-report/list'}"
                                   href="/contract-equipment-as-at-report/list" class='removeActive'>
                        Contract Equipment Listing As At
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menucontractequiputilization === true">
                    <li id="contractEquipUtilizationReportLink">
                      <router-link v-bind:to="{ path:'/contract-equipment-utilization-report/list'}"
                                   href="/contract-equipment-utilization-report/list" class='removeActive'>
                        Contract Equipment Utilization
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menusubstituteunitreport === true">
                    <li id="unitsWithoutActiveContractsLink">
                      <router-link v-bind:to="{ path:'/units-without-active-contracts/list'}"
                                   href="/units-without-active-contracts/list">
                        Units Without Active Contracts
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menusubstituteunitreport === true">
                    <li id="maintenanceinclusionsandLink">
                      <router-link v-bind:to="{ path:'/maintenance-inclusions-and-exclusions-report/list'}"
                                   href="/maintenance-inclusions-and-exclusions-report/list">
                        Maintenance Inclusions and Exclusions
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menucpiratereport === true">
                    <li id="cpirateverificationLink">
                      <router-link v-bind:to="{ path:'/cpi-rate-verification-report/list'}"
                                   href="/cpi-rate-verification-report/list">
                        CPI Rate Verification
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
              <li id="LRInsuranceReport" v-if="menuleaserentalinsurancereview === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Insurance
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
              </li>
              <li id="RentalReport" v-if="menuavailableequipmentreport === true || menucustomerrentalscoperatereport === true || menureservationreport === true || menurentallistingreport === true || menurentalactivityreport === true
                                                  || menurentalactivitywithratesreport === true || menusubstituteunitreport === true">
                <label class="tree-toggle nav-header">
                  <a href="javascript:void(0)">
                    Rental
                    <i aria-hidden="true" class="fp-down-arrow"></i>
                  </a>
                </label>
                <ul class="nav tree dr-tree">
                  <template v-if="menuavailableequipmentreport === true">
                    <li id="availableEquipmentReportLink">
                      <router-link v-bind:to="{ path:'/available-equipment-report/list'}"
                                   href="/available-equipment-report/list">
                        Available Equipment
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menucustomerrentalscoperatereport === true">
                    <li id="scoperateReportLink">
                      <router-link v-bind:to="{ path:'/customer-rental-scoperate-report/list'}"
                                   href="/customer-rental-scoperate-report/list">
                        Customer Rental Scope Rates
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menureservationreport === true">
                    <li id="reservationReportLink">
                      <router-link v-bind:to="{ path:'/reservation-report/list'}" href="/reservation-report/list">
                        Reservation Listing
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menurentallistingreport === true">
                    <li id="rentalListReportLink">
                      <router-link v-bind:to="{ path:'/rental-report/list'}" href="/rental-report/list">
                        Rental Listing
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menurentalactivityreport === true">
                    <li id="rentalActivityLink">
                      <router-link v-bind:to="{ path:'/rental-activity-report/list'}"
                                   href="/rental-activity-report/list">
                        Rental Activity Report
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menurentalactivitywithratesreport === true">
                    <li id="rentalActivityRatesLink">
                      <router-link v-bind:to="{ path:'/rental-activity-rates-report/list'}"
                                   href="/rental-activity-rates-report/list">
                        Rental Activity With Rates
                      </router-link>
                    </li>
                  </template>
                  <template v-if="menusubstituteunitreport === true">
                    <li id="substituteLink">
                      <router-link v-bind:to="{ path:'/substitute-unit-report/list'}"
                                   href="/substitute-unit-report/list">
                        Sub Days In Period
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
            </ul>
          </li>
          <li id="SupportReportLink" v-if="menufuelticket === true">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-accounting"> </i>
                Support Reports
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <template v-if="menuvehiclepermit === true">
                <li id="nonBillableUnitLink">
                  <router-link v-bind:to="{ path:'/non-billable-unit-report/list'}"
                               href="/non-billable-unit-report/list">
                    Velocity Non Billable Units
                  </router-link>
                </li>
              </template>
              <template v-if="menuvehiclepermit === true">
                <li id="equipmentaccountingrecords">
                  <router-link v-bind:to="{ path:'/equipment-accounting-records-report/list'}"
                               href="/equipment-accounting-records-report/list">
                    Equipment Accounting Records
                  </router-link>
                </li>
              </template>
            </ul>
          </li>
          <li id="TestingTabLink" v-if="menuweeklyrentalreport === true">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-rental-truck"> </i>
                Testing
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <template v-if="menuweeklyrentalreport === true">
                <li id="weeklyRentalReportLink">
                  <router-link v-bind:to="{ path:'/weekly-rental-report/list' }" href="/weekly-rental-report/list">
                    Weekly Rental Report
                  </router-link>
                </li>
              </template>
            </ul>
          </li>
          <template>
            <li id="batchLink">
              <router-link v-bind:to="{ path:'/batch/list'}" href="/batch/list">
                <i class="fp-batch"> </i>
                Batch
              </router-link>
            </li>
          </template>
          <template v-if="menupermitentryreport === true">
            <li id="permitReportLink">
              <router-link v-bind:to="{ path:'/permit-entry-report/list'}" href="/permit-entry-report/list">
                Permit in Entry Status
              </router-link>
            </li>
          </template>


          <template v-if="menuschedulereport === true">
            <li id="schedulereportLink">
              <router-link v-bind:to="{ path:'/schedule-report/list'}" class='removeActive'>
                Schedule Reports
              </router-link>
            </li>
          </template>

          <template v-if="menupotentialcancellationreport === true">
            <li id="potentialCancellationLink">
              <router-link v-bind:to="{ path:'/report/potential-cancellation'}" href="/report/potential-cancellation">
                Potential Cancellation
              </router-link>
            </li>
          </template>
          <template v-if="menurentalcancellationreport === true">
            <li id="rentalCancellationLink">
              <router-link v-bind:to="{ path:'/report/rental-cancellation'}" href="/report/rental-cancellation">
                Rental Cancellation
              </router-link>
            </li>
          </template>

          <template v-if="menemailreport === true">
            <li id="mailReportLink">
              <router-link v-bind:to="{ path:'/report/emails'}" href="/report/emails">
                Emails Report
              </router-link>
            </li>
          </template>
          <template v-if="menuoverdue === true">
            <li id="menuoverdueLink">
              <router-link v-bind:to="{ path:'/available-overdue-asset/list'}" href="/available-overdue-asset/list">
                Available & Overdue Asset
              </router-link>
            </li>
          </template>
          <template v-if="rentalutilizeasset === true">
            <li id="utilizeAssetReportLink">
              <router-link v-bind:to="{ path:'/report/utilize-asset'}" href="/report/utilize-asset">
                Rental Utilization Equipment
              </router-link>
            </li>
          </template>
          <template v-if="menuchargecodeaccount === true">
            <li id="chargeCodeAccountLink">
              <router-link v-bind:to="{ path:'/charge-code-account/list'}" href="/charge-code-account/list">
                Charge Code Account
              </router-link>
            </li>
          </template>
        </template>
      </template>

      <!--          the side bar for the EV-->
      <template v-else>

        <template>
          <template v-if="menudashboard">
            <li id="dashboardLink">
                <router-link :to="{ path: '/dashboard', name: 'Dashboard' }" class='removeActive'>
                <i class="fa fa-home" aria-hidden="true" style="line-height: 45px;"></i>
                  <div class="menu-text">
                    Home
                  </div>
                </router-link>
            </li>
          </template>

          <template v-if="ev_customer">
            <li id="dealerLink">
              <router-link v-bind:to="{ path: '/dealer/list' }">
                <i class="fp-customer"> </i>
                <div class="menu-text">
                  Dealers
                </div>
              </router-link>
            </li>
          </template>


          <template v-if="evConsumer">
            <li id="consumerLink">
              <router-link v-bind:to="{ path: '/customer/list' }">
                <i class="fp-customer"> </i>
                <div class="menu-text">
                  Customers
                </div>
              </router-link>
            </li>
          </template>

          <li v-if="ev_vehicle" id="assetTabLink">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-truck-asset"> </i>
                <div class="menu-text">
                  Vehicle Management
                </div>
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <template v-if="ev_vehicle && ev_all_vehicle">
                <li id="allVehicles">
                  <router-link v-bind:to="{ path: '/all-vehicles/list' }">
                    All Vehicles
                  </router-link>
                </li>
              </template>
              <template v-if="ev_vehicle">
                <li id="availableVehicleLink">
                  <router-link v-bind:to="{ path: '/available-vehicles/list' }">
                    Available Vehicles
                  </router-link>
                </li>
              </template>
              <template v-if="(ev_my_vehicle) && (ev_vehicle)">
                <li id="myVehicleLink">
                  <router-link v-bind:to="{ path: '/my-vehicles/list' }">
                    My Vehicles
                  </router-link>
                </li>
              </template>
              <template v-if="ev_vehicle_order_add">
                <li id="vehicleOrderFormLink">
                  <router-link v-bind:to="{ path: '/vehicle-order-form/create' }" class='removeActive'>
                    Vehicle Order Form
                  </router-link>
                </li>
              </template>
              <template v-if="ev_vehicle_order">
                <li id="vehicleOrderTrackingLink">
                  <router-link v-bind:to="{ path: '/vehicle-order/list' }" class='removeActive'>
                    Vehicle Order Tracking
                  </router-link>
                </li>
              </template>
              <template v-if="vehicleOptionCreate">
                <li id="vehicleOptionsLink">
                  <router-link v-bind:to="{ path: '/vehicle-option/list' }" class='removeActive'>
                    Vehicle Options
                  </router-link>
                </li>
              </template>
              <template v-if="retailDeliveryReport">
                <li id="retailDeliveryLink">
                  <router-link v-bind:to="{ path: '/retail-delivery-report/list' }" class='removeActive'>
                    Retail Delivery / Rizon Connect Registration
                  </router-link>
                </li>
              </template>
            </ul>
          </li>
          <li id="inventoryTabLink" v-if="ev_inventory || ev_part_order_create || ev_part_order || ev_part_catalog">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-inventory"> </i>
                <div class="menu-text">
                Parts
                </div>
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <template v-if="ev_inventory === true">
                <li id="compTransactionLink">
                  <router-link v-bind:to="{ path: '/pdc-stock/list' }" href="/pdc-stock/list">
                    PDC Stock
                  </router-link>
                </li>
              </template>
              <template v-if="ev_part_order_create">
                <li id="partOrderFormLink">
                  <router-link v-bind:to="{ path: '/part-order/create?type=contract' }"
                               href="/part-order/create?type=contract">
                    Order Parts
                  </router-link>
                </li>
              </template>
              <template v-if="ev_part_order">
                <li id="partOrderListLink">
                  <router-link v-bind:to="{ path: '/order-history/list' }" href="/order-history/list">
                    Order History
                  </router-link>
                </li>
              </template>
              <template v-if="ev_part_catalog">
                <li id="partOrderListLink">
                  <a
                    target="_blank"
                    href="https://ascent2.mitsubishi-fuso.com/PartsCatalogue/TextualSearch">
                    Parts Catalog
                  </a>
                </li>
              </template>
              <template v-if="ev_part_backorder_reporting">
                <li id="partOrderBackorderReport">
                  <router-link v-bind:to="{ path: '/part-backorder-report' }" href="/part-backorder-report">
                    Backorder Reporting
                  </router-link>
                </li>
              </template>
            </ul>
          </li>

          <li id="warrantyTabLink" v-if="ev_warranty === true">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-warranty"></i>
                <div class="menu-text">
                  Warranty
                </div>
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <template v-if="menuvehicleregistration">
                <li id="vehicleRegistrationTrackingLink">
                  <router-link v-bind:to="{ path: '/warrantyregistration/list' }" href="/warrantyregistration/list">
                    Warranty Registration Tracking
                  </router-link>
                </li>
              </template>
              <template v-if="menuvehicleregistration">
                <li id="vehicleRegistrationLink">
                  <router-link v-bind:to="{ path: '/warrantyregistration/add' }" href="/warrantyregistration/add">
                    Warranty Registration
                  </router-link>
                </li>
              </template>
              <template v-if="creditMemoLog">
                <li id="warrantyCreditMemoDataLogLink">
                  <router-link v-bind:to="{ path: '/credit-memo-log' }" href="/credit-memo-log">
                    Warranty Credit Memo Data Log
                  </router-link>
                </li>
              </template>
              <template>
                <li id="vehicleInformationLink">
                  <router-link v-bind:to="{ path: '/vehicle-information' }" href="/vehicle-information">
                    Vehicle Information
                  </router-link>
                </li>
              </template>
              <!-- <template v-if="ev_warranty_menu">
                          <li id="warrantyLink">
                            <router-link v-bind:to="{ path: '/warranty/list' }" href="/warranty/list">
                              Warranty
                            </router-link>
                          </li>
                        </template> -->
              <template v-if="ev_claim">
                <li id="claimLink">
                  <router-link v-bind:to="{ path: '/warranty-claim/queue' }" href="/warranty-claim/queue">
                    Claims
                  </router-link>
                </li>
              </template>
              <!-- <template v-if="ev_claim_collection">
                          <li id="collectionLink">
                            <router-link v-bind:to="{ path: '/list/claim-collection' }" href="/list/claim-collection">
                              Collections
                            </router-link>
                          </li>
                        </template> -->
              <template v-if="evRate">
                <li id="rateLink">
                  <router-link v-bind:to="{ path: '/rates/list' }" href="/rates/list">
                    Rates
                  </router-link>
                </li>
              </template>
              <template v-if="evSrt">
                <li id="srtLink">
                  <router-link v-bind:to="{ path: '/srt/list' }" href="/srt/list">
                    SRT
                  </router-link>
                </li>
              </template>
              <template v-if="evPositionCode">
                <li id="positionCodeLink">
                  <router-link v-bind:to="{ path: '/position-code/list' }" href="/position-code/list">
                    Position Code
                  </router-link>
                </li>
              </template>
              <template v-if="damageCode=== true">
                <li id="damageCodeLink">
                  <router-link v-bind:to="{ path:'/damage-code/list'}" href="/damage-code/list">
                    Damage Code
                  </router-link>
                </li>
              </template>
            </ul>
          </li>
          <template>
            <li id="publicationLink">
              <router-link v-bind:to="{ path:'/publication/list'}" href="/publication/list">
                <i class="fp-transport-request-form"> </i>
                <div class="menu-text">
                  Publications
                </div>
              </router-link>
            </li>
          </template>
          <template v-if="campaignRecall">
            <li id="campaignTabLink">
              <label class="tree-toggle nav-header">
                <a href="javascript:void(0)">
                  <i class="fp-agreement"></i>
                  <div class="menu-text">
                    Campaigns/Recalls
                  </div>
                  <i aria-hidden="true" class="fp-down-arrow"></i>
                </a>
              </label>
              <ul class="nav tree">
                <template>
                  <li id="campaignLink">
                    <router-link v-bind:to="{ path:'/campaign/list'}" href="/campaign/list">
                      Campaigns/Recalls
                    </router-link>
                  </li>
                </template>
                <template v-if="statusTracking">
                  <li id="campaignRecallStatusLink">
                    <router-link v-bind:to="{ path:'/campaign-recall-status/list'}" href="/campaign-recall-status/list">
                      Status Tracking
                    </router-link>
                  </li>
                </template>
              </ul>
            </li>
          </template>
          <template v-if="technicalSupportRequest">
            <li id="serviceTabLink">
              <label class="tree-toggle nav-header">
                <a href="javascript:void(0)">
                  <i class="fa fa-wrench" aria-hidden="true" style="line-height: 45px;"></i>
                  <div class="menu-text">
                  Service
                  </div>
                  <i aria-hidden="true" class="fp-down-arrow"></i>
                </a>
              </label>
              <ul class="nav tree">
                <template v-if="technicalSupportRequest">
                  <li id="serviceTechnicalSupportRequest">
                    <router-link v-bind:to="{ path:'/technical-support-request'}" href="/technical-support-request">
                      Technical Support Request
                    </router-link>
                  </li>
                </template>
              </ul>
              <ul class="nav tree">
                <template v-if="technicalSupportQueue">
                  <li id="serviceTechnicalSupportQueue">
                    <router-link v-bind:to="{ path:'/technical-support-queue'}" href="/technical-support-queue">
                      Technical Support Queue
                      <div v-if="isAdminUser && technicalCount" style="position: relative;">
                        <i class="fa fa-bell" style="font-size: 20px; color: black;"></i>
                        <span class='notification-count-badge' style="top: -3px !important;right: 9px !important;">
                          {{ technicalCount }}
                        </span>
                      </div>
                    </router-link>
                  </li>
                </template>
              </ul>
            </li>
          </template>
<!--          <template v-if="menucrm === true">-->
<!--            <li id="crmLink">-->
<!--              <router-link v-bind:to="{ path: '/crm/list' }" href="/crm/list">-->
<!--                <i class="fp-agreement"> </i>-->
<!--                <div class="menu-text">-->
<!--                CRM-->
<!--                </div>-->
<!--              </router-link>-->
<!--            </li>-->
<!--          </template>-->

          <template v-if="menuactivitylog === true">
            <li id="activityLink">
              <router-link v-bind:to="{ path: '/activitylog/list' }" class='removeActive'>
                <i class="fp-log-file-format"> </i>
                <div class="menu-text">
                  Activity Logs
                </div>
              </router-link>
            </li>
          </template>

          <template v-if="menuuser === true">
            <li id="userLink">
              <router-link v-bind:to="{ path: '/user/list' }" class='removeActive'>
                <i class="fp-user"> </i>
                <div class="menu-text">
                  Users
                </div>
              </router-link>
            </li>
          </template>

          <template v-if="ev_gallery">
            <li id="galleryLink">
              <router-link v-bind:to="{ name: 'GalleryList' }" class='removeActive'>
                <i class="fa fa-picture-o" aria-hidden="true" style="line-height: 45px;font-size: 18px;"></i>
                <div class="menu-text">
                  Gallery
                </div>
              </router-link>
            </li>
          </template>

          <!-- Setting links -->
          <li id="settingLink" v-if="ev_setting">
            <label class="tree-toggle nav-header">
              <a href="javascript:void(0)">
                <i class="fp-settings"> </i>
                <div class="menu-text">
                  Settings
                </div>
                <i aria-hidden="true" class="fp-down-arrow"></i>
              </a>
            </label>
            <ul class="nav tree">
              <template v-if="menurole">
                <li id="roleLink">
                  <router-link v-bind:to="{ path: '/roles/list' }" href="/roles/list">
                    Roles
                  </router-link>
                </li>
              </template>
              <template v-if="menugrantpermission">
                <li id="grantPermissionLink">
                  <router-link v-bind:to="{ path: '/grantpermission' }" href="/grantpermission">
                    Grant Permissions
                  </router-link>
                </li>
              </template>

              <template v-if="menulocation">
                <li id="locationLink">
                  <router-link v-bind:to="{ path:'/location/list'}" href="/location/list">
                    Locations
                  </router-link>
                </li>
              </template>

              <template>
                <li id="systemParamLink" v-if="systemParam === true">
                  <router-link v-bind:to="{ path: '/system-param/list' }" href="/system-param/list">
                    System Param
                  </router-link>
                </li>
              </template>
            </ul>
          </li>
          <template v-if="report_concern">
            <li id="reportConcernLink" class="report-concern-link" >
              <router-link v-bind:to="{ path:'/report-concern'}" href="/report-concern">
                <i class="fp-transport-request-form"> </i>
                <div class="menu-text">
                  Report a Concern
                </div>
              </router-link>
            </li>
          </template>
          <template v-if="feedback_log">
            <li id="userFeedbackLink">
              <router-link v-bind:to="{ path:'/feedback-log'}" href="/feedback-log">
                <i class="fp-edit"> </i>
                <div class="menu-text">
                  Feedback Log
                </div>
                <div v-if="feedbackCount" style="position: relative;padding-right: 15px;">
                  <i class="fa fa-bell" style="font-size: 20px; color: black;"></i>
                  <span class='notification-count-badge'>
                    {{ feedbackCount }}
                  </span>
                </div>
              </router-link>
            </li>
          </template>
        </template>
      </template>
    </ul>
  </div>

</template>
<script>
import EventBus from './event-bus';

var contex
export default {
  name: 'sidebar-wrapper',
  data: () => ({
    loadMenuLinksFor: "",
    userRole: '',
    permissions: [],
    menuuser: false,
    menuvendor: false,
    menureservation: false,
    menugroup: false,
    menuvehiclestatus: false,
    menuvehicletype: false,
    menuvehicleregistration: false,
    menuvehiclemanufacturer: false,
    menuvehiclemodel: false,
    menurole: false,
    menugrantpermission: false,
    menushop: false,
    menuvehiclegroup: false,
    menumeasurementunit: false,
    menuvehicleownership: false,
    menuvehiclepool: false,
    menulocation: false,
    menurepresentative: false,
    menuactivitylog: false,
    menuVechicle: false,
    menuvehiclelocationhistory: false,
    menuvehicledefect: false,
    menuvehiclecontracthistory: false,
    menuitemManufacturer: false,
    menuitemrental: false,
    menuitemlease: false,
    menuitemcategories: false,
    menuwarranties: false,
    menuitem: false,
    menuwarehouse: false,
    menuwarehouseBinMapper: false,
    menucpicode: false,
    menucontractbillingmethod: false,
    menucontractbillingfrequency: false,
    menucustomerclass: false,
    menucontracttype: false,
    menucustomer: false,
    menuterm: false,
    menucustomercontact: false,
    menucontract: false,
    menumetrictype: false,
    menuvehiclemaintanancereportingstandards: false,
    menuinsurancecompany: false,
    menuinsurancepolicy: false,
    menuinsurancecertificate: false,
    menurentalagreement: false,
    menucontractunitdetail: false,
    menucontracttypesectionmapper: false,
    menueffectivecpirate: false,
    menucpiproofreview: false,
    menudashboard: false,
    menucpiacknowledgementmailsent: false,
    menuenquiry: false,
    menucharges: false,
    menuextracharges: false,
    menuinvoice: false,
    menuaccountsrececivableinquiry: false,
    menurefundpaymentlist: false,
    menurefundeligiblelist: false,
    menupayment: false,
    menuimportdatareview: false,
    menuimportdata: false,
    rentalLink: "",
    token: "",
    menuscoperate: false,
    menucustomerdiscount: false,
    menuunsynceddata: false,
    transportrequest: false,
    travelrequest: false,
    etkrequest: false,
    indirectcoderequest: false,
    menulaborcode: false,
    menuuserlogentry: false,
    menupendingreservation: false,
    enToken: true,
    flashit_value: false,
    showSidebarMenu: true,
    menucredit: false,
    menuach: false,
    menuvehiclepermittype: false,
    menuvehiclepermit: false,
    menuassetcomponent: false,
    menuassetstandardfeature: false,
    menuassetfeaturecategory: false,
    menuassetfeature: false,
    menufeature: false,
    menustandarddefact: false,
    menuworkordertemplate: false,
    damageCode: false,
    menuworkorder: false,
    menuworkorderestimate: false,
    menuschedule: false,
    menupurchaseorderdetail: false,
    menupurchaseorderassetdetail: false,
    menucrm: false,
    menuassetinventory: false,
    menuinsuranceagency: false,
    menuchecklistaction: false,
    menurecallassetmapper: false,
    menuglaccount: false,
    menubill: false,
    defaultpricebook: false,
    pricebookhistory: false,
    approvedOrder: false,
    requisition: false,
    menucreditnote: false,
    menuvehiclehvut: false,
    menuvehiclelogs: false,
    menuhvutcategory: false,
    menuhvutexception: false,
    menujournal: false,
    faqadd: false,
    menuglreport: false,
    menuwrongglreport: false,
    companyinfo: false,
    menuvendorpayment: false,
    menucheck: false,
    newsinfo: false,
    systemParam: false,
    showJobs: false,
    jobinfo: false,
    menutransfer: false,
    menudebtNote: false,
    menudebtNoteReconciliation: false,
    menufuelpricing: false,
    menufuelislandproduct: false,
    menufueldrop: false,
    menureceipt: false,
    menufuelticket: false,
    menufuelreading: false,
    menucourtesynotice: false,
    menupastduenotice: false,
    menuachnotice: false,
    menuunitreading: false,
    menucustomerloginreport: false,
    menucustomerregisterreport: false,
    menucustomerinteractionreport: false,
    menupotentialcancellationreport: false,
    menurentalcancellationreport: false,
    menemailreport: false,
    menubillingforecast: false,
    menucustomerneed: false,
    accountsetting: false,
    menuschedulereport: false,
    menutaxsummaryreport: false,
    menuincomesummaryreport: false,
    menuexpensesummaryreport: false,
    menuprofitlossreport: false,
    menuoverdue: false,
    menutrialbalance: false,
    menusubletinprocess: false,
    menufuelinventoryclearingreport: false,
    menuaccruedliability: false,
    menucustomeraroutstanding: false,
    menudepreciation: false,
    menuvehiclesale: false,
    menucapitalcost: false,
    menubatch: false,
    comptransaction: false,
    role: '',
    poreceipt: false,
    physicalCountList: false,
    rentalutilizeasset: false,
    menugangsheet: false,
    menurentalpo: false,
    menusuggestedorder: false,
    menuchargecodeaccount: false,
    menulaborcost: false,
    menuapprovedworkorder: false,
    menushiftdetail: false,
    menucitation: false,
    menuvmrs: false,
    menuoutofservice: false,
    menuagedtrialbalsummary: false,
    menuagedtrialbaldetail: false,
    menunotepadreview: false,
    menuagedtrialbaldetailgrid: false,
    menuappaymentupload: false,
    menuaptrialbalancedetailasat: false,
    menuapvoucherdistribution: false,
    menuarreceiptandapplication: false,
    menuwoaccounttransaction: false,
    menuopenonaccountcash: false,
    menultdunitprofitloss: false,
    menumileageupload: false,
    menuinvoiceDetail: false,
    laborManage: false,
    menusubsystem: false,
    menuprogram: false,
    menuequipmentcurrentstatus: false,
    menuequipmentpooltransfer: false,
    menudepreciationreview: false,
    menudepreciationnbv: false,
    menudisposalinvoice: false,
    menuinsurancepolicyreport: false,
    menuownedequipmentreport: false,
    menuequipmentmaster: false,
    menucostpermetricreport: false,
    menuequipmentfeaturereport: false,
    menucontractrevenuereport: false,
    menugangsheetreport: false,
    menuoutofservicehistory: false,
    menurepairhistoryreport: false,
    menuinventorydetailreport: false,
    menupmunitdetailreport: false,
    menupmunitforecastreport: false,
    menupmcompliancefacilityreport: false,
    menupmcompliancepoolreport: false,
    menucustomerreport: false,
    menuinvoicelistreport: false,
    menufuelticketdetail: false,
    menuunitpermitdetail: false,
    menuhvutunitdetail: false,
    menubillreadingforperiodreport: false,
    menumetricsbilledreport: false,
    menumanualbiiling: true,
    menunetbillingmetricsforperiod: false,
    menuleasecontractreport: false,
    menuleasecontractexpiryreport: false,
    menuratesandutilizationreport: false,
    totalFleetReport: false,
    menucontractcustomerreport: false,
    menucontractequipmentreport: false,
    menucontractequiputilization: false,
    menuleaserentalinsurancereview: false,
    menuavailableequipmentreport: false,
    menucustomerrentalscoperatereport: false,
    menureservationreport: false,
    menurentallistingreport: false,
    menurentalactivityreport: false,
    menurentalactivitywithratesreport: false,
    menusubstituteunitreport: false,
    menucpiratereport: false,
    menuweeklyrentalreport: false,
    menupermitentryreport: false,
    menunotes: false,
    menuwarrantyclaim: false,
    menuworkorderinvoice: false,
    menuappositivepaylistingreport: false,
    menushopporeport: false,
    menucustomerinvoiceline: false,
    menudebtnotebalance: false,
    menudebtnoteunitdetail: false,
    menudebtnotepostingdetail: false,
    menuleaveholidaycalendar: false,
    menudebtnoteschedule: false,
    subjectList: false,
    feedback: false,
    menuvoucherpayment: false,
    menuGLBalance: false,
    velocity_env: process.env.NODE_ENV,
    isEv: false,
    ev_inventory: false,
    ev_part_order: false,
    ev_part_order_create: false,
    ev_warranty: false,
    ev_claim: false,
    ev_claim_collection: false,
    ev_vehicle: false,
    ev_all_vehicle: false,
    ev_vehicle_order: false,
    ev_vehicle_order_add: false,
    ev_customer: false,
    ev_setting: false,
    ev_my_vehicle: false,
    menutypedeposit: false,
    customerIdExist: false,
    evConsumer: false,
    evRate: false,
    campaignRecall: false,
    statusTracking: false,
    ev_part_catalog: false,
    evSrt: false,
    ev_warranty_menu: false,
    report_concern: false,
    feedback_log: false,
    ev_gallery: false,
    technicalSupportRequest: false,
    technicalSupportQueue: false,
    vehicleOptionCreate: false,
    feedbackCount: 0,
    technicalCount: 0,
    isAdminUser: false,
    ev_part_backorder_reporting: false,
    retailDeliveryReport: false,
    creditMemoLog: false,
    evPositionCode: false
  }),
  watch: {

    permissions: function (permissions) {


      var self = this;
      if (permissions.length > 0) {

        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name == 'list_user') {
            self.menuuser = true;
            continue;
          }
          if (permissions[i].name == 'list_vendor') {
            self.menuvendor = true;
            continue;
          }
          if (permissions[i].name == 'list_reservation') {
            self.menureservation = true;
            continue;
          }
          if (permissions[i].name == 'list_pending_reservation') {
            self.menupendingreservation = true;
            continue;
          }
          if (permissions[i].name == 'list_group') {
            self.menugroup = true;
            continue;
          }
          if (permissions[i].name == 'list_asset_status') {
            self.menuvehiclestatus = true;
            continue;
          }
          if (permissions[i].name == 'list_asset_type') {
            self.menuvehicletype = true;
            self.menutypedeposit = true;
            continue;
          }
          //if(self.velocity_env == 'velev' || self.velocity_env == 'velev_test'){
          if (permissions[i].name == 'list_vehicle_registration' || permissions[i].name == 'ev_list_vehicle_registration') {
            self.menuvehicleregistration = true;
            continue;
          }
          //}
          if (permissions[i].name == 'list_asset_manufacturer') {
            self.menuvehiclemanufacturer = true;
            continue;
          }
          if (permissions[i].name == 'list_asset_model') {
            self.menuvehiclemodel = true;
            continue;
          }
          if (permissions[i].name == 'list_asset_ownership') {
            self.menuvehicleownership = true;
            continue;
          }
          if (permissions[i].name == 'list_asset_pool') {
            self.menuvehiclepool = true;
            continue;
          }
          if (permissions[i].name == 'list_role') {
            self.menurole = true;
            continue;
          }
          if (permissions[i].name == 'list_program') {
            self.menuprogram = true;
            continue;
          }

          if (permissions[i].name == 'list_indirect_code') {
            self.indirectcoderequest = true;
            continue;
          }

          if (permissions[i].name == 'grant_permission') {
            self.menugrantpermission = true;
            continue;
          }
          if (permissions[i].name == 'list_shop') {
            self.menushop = true;
            continue;
          }
          if (permissions[i].name == 'list_asset_group') {
            self.menuvehiclegroup = true;
            continue;
          }
          if (permissions[i].name == 'list_measurement_unit') {
            self.menumeasurementunit = true;
            continue;
          }
          if (permissions[i].name == 'list_location') {
            self.menulocation = true;
            continue;
          }
          if (permissions[i].name == 'list_representative') {
            self.menurepresentative = true;
            continue;
          }
          if (permissions[i].name == 'list_activity_log') {
            self.menuactivitylog = true;
            continue;
          }
          if (permissions[i].name == 'list_asset') {
            self.menuVechicle = true;
            continue;
          }
          if (permissions[i].name == 'list_asset_defect') {
            self.menuvehicledefect = true;
            continue;
          }
          if (permissions[i].name == 'list_import_data_review') {
            self.menuimportdatareview = true;
            continue;
          }
          if (permissions[i].name == 'list_asset_contract_history') {
            self.menuvehiclecontracthistory = true;
            continue;
          }
          if (permissions[i].name == 'list_component_manufacturer') {
            self.menuitemManufacturer = true;
            continue;
          }
          if (permissions[i].name == 'list_rental_reservation') {
            self.menuitemrental = true;
            continue;
          }
          if (permissions[i].name == 'list_lease_reservation') {
            self.menuitemlease = true;
            continue;
          }
          if (permissions[i].name == 'list_component_categories') {
            self.menuitemcategories = true;
            continue;
          }
          if (permissions[i].name == 'list_warranty') {
            self.menuwarranties = true;
            continue;
          }
          if (permissions[i].name == 'list_component') {
            self.menuitem = true;
            continue;
          }
          if (permissions[i].name == 'list_warehouse') {
            self.menuwarehouse = true;
            continue;
          }
          if (permissions[i].name == 'list_warehouse_bin_mapper') {
            self.menuwarehouseBinMapper = true;
            continue;
          }

          if (permissions[i].name == 'list_cpi_code') {
            self.menucpicode = true;
            continue;
          }
          if (permissions[i].name == 'list_contract_billing_method') {
            self.menucontractbillingmethod = true;
            continue;
          }
          if (permissions[i].name == 'list_contract_billing_frequency') {
            self.menucontractbillingfrequency = true;
            continue;
          }
          if (permissions[i].name == 'list_customer_class') {
            self.menucustomerclass = true;
            continue;
          }
          if (permissions[i].name == 'list_contract_type') {
            self.menucontracttype = true;
            continue;
          }
          if (permissions[i].name == 'list_customer') {
            self.menucustomer = true;
            continue;
          }
          if (permissions[i].name == 'list_term') {
            self.menuterm = true;
            continue;
          }
          if (permissions[i].name == 'list_customer_contact') {
            self.menucustomercontact = true;
            continue;
          }
          if (permissions[i].name == 'list_contract') {
            self.menucontract = true;
            continue;
          }
          if (permissions[i].name == 'list_metric_type') {
            self.menumetrictype = true;
            continue;
          }
          if (permissions[i].name == 'list_asset_maintanance_reporting_standards') {
            self.menuvehiclemaintanancereportingstandards = true;
            continue;
          }
          if (permissions[i].name == 'list_insurance_company') {
            self.menuinsurancecompany = true;
            continue;
          }
          if (permissions[i].name == 'list_insurance_policies') {
            self.menuinsurancepolicy = true;
            continue;
          }
          if (permissions[i].name == 'list_insurance_certificate') {
            self.menuinsurancecertificate = true;
            continue;
          }
          if (permissions[i].name == 'list_rental_agreement') {
            self.menurentalagreement = true;
            continue;
          }
          if (permissions[i].name == 'list_contract_asset_detail') {
            self.menucontractunitdetail = true;
            continue;
          }
          if (permissions[i].name == 'list_contract_type_section_mapper') {
            self.menucontracttypesectionmapper = true;
            continue;
          }
          if (permissions[i].name == 'list_effective_cpi_rate') {
            self.menueffectivecpirate = true;
            continue;
          }
          if (permissions[i].name == 'list_cpi_proof_review') {
            self.menucpiproofreview = true;
            continue;
          }
          if (permissions[i].name == 'dashboard') {
            self.menudashboard = true;
            continue;
          }
          if (permissions[i].name == 'list_cpi_acknowledgement_mail_sent') {
            self.menucpiacknowledgementmailsent = true;
            continue;
          }
          if (permissions[i].name == 'list_enquiry') {
            self.menuenquiry = true;
            continue;
          }
          if (permissions[i].name == 'list_charges') {
            self.menucharges = true;
            continue;
          }
          if (permissions[i].name == 'list_rate') {
            self.menuscoperate = true;
            continue;
          }
          if (permissions[i].name == 'list_customer_discount') {
            self.menucustomerdiscount = true;
            continue;
          }
          if (permissions[i].name == 'list_invoice') {
            self.menuinvoice = true;
            continue;
          }
          if (permissions[i].name == 'accounts_rececivable_inquiry') {
            self.menuaccountsrececivableinquiry = true;
            continue;
          }
          if (permissions[i].name == 'refund_payment_list') {
            self.menurefundpaymentlist = true;
            continue;
          }
          if (permissions[i].name == 'refund_eligible_customers') {
            self.menurefundeligiblelist = true;
            continue;
          }
          if (permissions[i].name == 'list_payment') {
            self.menupayment = true;
            continue;
          }
          if (permissions[i].name == 'list_unsync_data') {
            self.menuunsynceddata = true;
            continue;
          }
          if (permissions[i].name == 'transport_request_list') {
            self.transportrequest = true;
            continue;
          }
          if (permissions[i].name == 'travel_request') {
            self.travelrequest = true;
            continue;
          }
          if (permissions[i].name == 'etk_list') {
            self.etkrequest = true;
            continue;
          }
          if (permissions[i].name == 'list_credit_application') {
            self.menucredit = true;
            continue;
          }
          if (permissions[i].name == 'list_ach_agreement') {
            self.menuach = true;
            continue;
          }
          if (permissions[i].name == 'list_asset_permit_type') {
            self.menuvehiclepermittype = true;
            continue;
          }
          if (permissions[i].name == 'list_asset_permit') {
            self.menuvehiclepermit = true;
            continue;
          }
          if (permissions[i].name == 'list_asset_component') {
            self.menuassetcomponent = true;
            continue;
          }
          if (permissions[i].name == 'list_asset_standard_feature') {
            self.menuassetstandardfeature = true;
            continue;
          }

          if (permissions[i].name == 'list_asset_feature_category') {
            self.menuassetfeaturecategory = true;
            continue;
          }
          if (permissions[i].name == 'list_feature') {
            self.menufeature = true;
            continue;
          }
          if (permissions[i].name == 'list_asset_feature') {
            self.menuassetfeature = true;
            continue;
          }
          if (permissions[i].name == 'list_standard_defect') {
            self.menustandarddefact = true;
            continue;
          }
          if (permissions[i].name == 'list_work_order_template') {
            self.menuworkordertemplate = true;
            continue;
          }
          if (permissions[i].name == 'list_damage_code') {
            self.damageCode = true;
            continue;
          }
          if (permissions[i].name == 'list_work_order') {
            self.menuworkorder = true;
            continue;
          }
          if (permissions[i].name == 'list_customer_estimate') {
            self.menuworkorderestimate = true;
            continue;
          }
          if (permissions[i].name == 'list_schedule_maintenance') {
            self.menuschedule = true;
            continue;
          }
          if (permissions[i].name == 'list_customer_purchase_order') {
            self.menurentalpo = true;
            continue;
          }
          if (permissions[i].name == 'list_suggested_order') {
            self.menusuggestedorder = true;
            continue;
          }
          if (permissions[i].name == 'list_purchase_order' || permissions[i].name == 'list_customer_purchase_order') {
            self.menupurchaseorderdetail = true;
            continue;
          }
          if (permissions[i].name == 'add_purchase_order') {
            self.menupurchaseorderassetdetail = true;
            continue;
          }
          // if (permissions[i].name == 'list_customer_purchase_order') {
          //     continue;
          // }

          if (permissions[i].name == 'list_crm') {
            self.menucrm = true;
            continue;
          }
          if (permissions[i].name == 'list_insurance_agency') {
            self.menuinsuranceagency = true;
            continue;
          }
          if (permissions[i].name == 'list_checklist_action') {
            self.menuchecklistaction = true;
            continue;
          }
          if (permissions[i].name == 'view_recall_asset_mapper') {
            self.menurecallassetmapper = true;
          }
          if (permissions[i].name == 'list_gl_account') {
            self.menuglaccount = true;
            continue;
          }
          if (permissions[i].name == 'list_vendor_invoice') {
            self.menubill = true;
            continue;
          }
          if (permissions[i].name == 'add_price_book') {
            self.defaultpricebook = true;
            self.pricebookhistory = true;
            continue;
          }

          if (permissions[i].name == 'add_asset_requisition') {
            self.approvedOrder = true;
            self.requisition = true;
            continue;
          }
          if (permissions[i].name == 'list_credit_note') {
            self.menucreditnote = true;
            continue;
          }
          if (permissions[i].name == 'list_hvut_schedule') {
            self.menuvehiclehvut = true;
            continue;
          }
          if (permissions[i].name == 'list_asset_location_history') {
            self.menuvehiclelogs = true;
            self.menuvehiclelocationhistory = true;
            continue;
          }

          if (permissions[i].name == 'list_hvut_category') {
            self.menuhvutcategory = true;
            continue;
          }
          if (permissions[i].name == 'list_journal') {
            self.menujournal = true;
            continue;
          }
          if (permissions[i].name == 'list_faq') {
            self.faqadd = true;
            self.feedback = true;
            continue;
          }
          if (permissions[i].name == 'general_ledger_report') {
            self.menuglreport = true;
            continue;
          }
          if (permissions[i].name == 'wrong_gl_list') {
            self.menuwrongglreport = true;
            continue;
          }
          if (permissions[i].name == 'add_company_info') {
            self.companyinfo = true;
            continue;
          }
          if (permissions[i].name == 'list_check') {
            self.menucheck = true;
            continue;
          }
          if (permissions[i].name == 'list_news') {
            self.newsinfo = true;
            continue;
          }
          if (permissions[i].name == 'list_system_param') {
            self.systemParam = true;
            continue;
          }
          if (permissions[i].name == 'list_job') {
            self.jobinfo = true;
            self.showJobs = true;
            continue;
          }
          if (permissions[i].name == 'list_vendor_payment') {
            self.menuvendorpayment = true;
            continue;
          }
          if (permissions[i].name == 'list_bank_transfer') {
            self.menutransfer = true;
            continue;
          }
          if (permissions[i].name == 'list_debt_notes') {
            self.menudebtNote = true;
            continue;
          }
          if (permissions[i].name == 'list_debt_note_reconciliation') {
            self.menudebtNoteReconciliation = true;
            continue;
          }
          if (permissions[i].name == 'list_fuel_pricing') {
            self.menufuelpricing = true;
            continue;
          }
          if (permissions[i].name == 'list_fuel_island_product') {
            self.menufuelislandproduct = true;
            continue;
          }
          if (permissions[i].name == 'list_fuel_drop') {
            self.menufueldrop = true;
            continue;
          }
          if (permissions[i].name == 'list_payment_receipt') {
            self.menureceipt = true;
            continue;
          }

          if (permissions[i].name == 'list_fuel_ticket') {
            self.menufuelticket = true;
            continue;
          }

          if (permissions[i].name == 'list_fuel_reading') {
            self.menufuelreading = true;
            continue;
          }
          if (permissions[i].name == 'list_courtesy_notice') {
            self.menucourtesynotice = true;
            continue;
          }
          if (permissions[i].name == 'list_past_due_notice') {
            self.menupastduenotice = true;
            continue;
          }
          if (permissions[i].name == 'list_ach_notice') {
            self.menuachnotice = true;
            continue;
          }
          if (permissions[i].name == 'odometer_reading_report') {
            self.menuunitreading = true;
            continue;
          }
          if (permissions[i].name == 'customer_login_report') {
            self.menucustomerloginreport = true;
            continue;
          }
          if (permissions[i].name == 'customer_register_report') {
            self.menucustomerregisterreport = true;
            continue;
          }
          if (permissions[i].name == 'customer_interaction_report') {
            self.menucustomerinteractionreport = true;
            continue;
          }
          if (permissions[i].name == 'list_potential_cancellation') {
            self.menupotentialcancellationreport = true;
            continue;
          }
          if (permissions[i].name == 'list_rental_cancellation') {
            self.menurentalcancellationreport = true;
            continue;
          }
          if (permissions[i].name == 'email_report') {
            self.menemailreport = true;
            continue;
          }
          if (permissions[i].name == 'billing_forecast_report') {
            self.menubillingforecast = true;
            continue;
          }
          if (permissions[i].name == 'add_extra_charges') {
            self.menuextracharges = true;
            continue;
          }
          if (permissions[i].name == 'import_data') {
            self.menuimportdata = true;
            continue;
          }
          if (permissions[i].name == 'asset_inventory') {
            self.menuassetinventory = true;
            continue;
          }
          if (permissions[i].name == 'add_customer_need') {
            self.menucustomerneed = true;
            continue;
          }
          if (permissions[i].name == 'default_account_setting') {
            self.accountsetting = true;
            continue;
          }
          if (permissions[i].name == 'list_schedule_report') {
            self.menuschedulereport = true;
            continue;
          }
          if (permissions[i].name == 'tax_summary_report') {
            self.menutaxsummaryreport = true;
            continue;
          }
          if (permissions[i].name == 'income_summary_report') {
            self.menuincomesummaryreport = true;
            continue;
          }
          if (permissions[i].name == 'expense_summary_report') {
            self.menuexpensesummaryreport = true;
            continue;
          }
          if (permissions[i].name == 'profit_and_loss_report') {
            self.menuprofitlossreport = true;
            continue;
          }
          if (permissions[i].name == 'trial_balance_report') {
            self.menutrialbalance = true;
            continue;
          }
          if (permissions[i].name == 'sublet_in_process_report') {
            self.menusubletinprocess = true;
            continue;
          }
          if (permissions[i].name == 'fuel_inventory_clearing_report') {
            self.menufuelinventoryclearingreport = true;
            continue;
          }
          if (permissions[i].name == 'accrued_liability_report') {
            self.menuaccruedliability = true;
            continue;
          }
          if (permissions[i].name == 'available_overdue_asset_report') {
            self.menuoverdue = true;
            continue;
          }
          if (permissions[i].name == 'rental_utilization_equipment_report') {
            self.rentalutilizeasset = true;
            continue;
          }
          if (permissions[i].name == 'customer_account_receivable_outstanding_report') {
            self.menucustomeraroutstanding = true;
            continue;
          }
          if (permissions[i].name == 'list_depreciation_schedule') {
            self.menudepreciation = true;
            continue;
          }

          if (permissions[i].name == 'list_asset_sales') {
            self.menuvehiclesale = true;
            continue;
          }
          if (permissions[i].name == 'list_capital_cost') {
            self.menucapitalcost = true;
            continue;
          }
          if (permissions[i].name == 'list_batch') {
            self.menubatch = true;
            continue;
          }
          if (permissions[i].name == 'list_component_transaction') {
            self.comptransaction = true;
            continue;
          }
          if (permissions[i].name == 'list_purchase_order_receipt') {
            self.poreceipt = true;
            continue;
          }
          if (permissions[i].name == 'list_physical_count') {
            self.physicalCountList = true;
            continue;
          }
          if (permissions[i].name == 'user_log_entry_list') {
            self.menuuserlogentry = true;
            self.menugangsheet = true;
            continue;
          }
          if (permissions[i].name == 'list_charge_code_account') {
            self.menuchargecodeaccount = true;
            continue;
          }
          if (permissions[i].name == 'list_labor_cost') {
            self.menulaborcost = true;
            continue;
          }
          if (permissions[i].name == 'list_approved_work_order') {
            self.menuapprovedworkorder = true;
            continue;
          }
          if (permissions[i].name == 'list_shift_detail') {
            self.menushiftdetail = true;
            continue;
          }
          if (permissions[i].name == 'list_citation') {
            self.menucitation = true;
            continue;
          }
          if (permissions[i].name == 'list_vmrs') {
            self.menuvmrs = true;
            continue;
          }
          if (permissions[i].name == 'out_of_service_list') {
            self.menuoutofservice = true;
            continue;
          }
          if (permissions[i].name == 'customer_aged_trial_balance_summary_report') {
            self.menuagedtrialbalsummary = true;
            continue;
          }
          if (permissions[i].name == 'customer_aged_trial_balance_detail_report') {
            self.menuagedtrialbaldetail = true;
            continue;
          }
          if (permissions[i].name == 'note_pad_review_report') {
            self.menunotepadreview = true;
            continue;
          }
          if (permissions[i].name == 'aged_trial_balance_detail_grid_report') {
            self.menuagedtrialbaldetailgrid = true;
            continue;
          }
          if (permissions[i].name == 'ap_payment_upload_report') {
            self.menuappaymentupload = true;
            continue;
          }
          if (permissions[i].name == 'ap_trial_balance_as_at_detail_report') {
            self.menuaptrialbalancedetailasat = true;
            continue;
          }
          if (permissions[i].name == 'ap_voucher_distribution_edit_report') {
            self.menuapvoucherdistribution = true;
            continue;
          }
          if (permissions[i].name == 'ar_receipts_and_applications_report') {
            self.menuarreceiptandapplication = true;
            continue;
          }
          if (permissions[i].name == 'work_order_accounting_transactions_report') {
            self.menuwoaccounttransaction = true;
            continue;
          }
          if (permissions[i].name == 'open_on_account_cash_report') {
            self.menuopenonaccountcash = true;
            continue;
          }
          if (permissions[i].name == 'ltd_unit_profit_and_loss_summary') {
            self.menultdunitprofitloss = true;
            continue;
          }
          if (permissions[i].name == 'list_mileage_upload') {
            self.menumileageupload = true;
            continue;
          }
          if (permissions[i].name == 'invoice_detail_report') {
            self.menuinvoiceDetail = true;
            continue;
          }
          if (permissions[i].name == 'labor_management_report') {
            self.laborManage = true;
            continue;
          }
          if (permissions[i].name == 'list_sub_system') {
            self.menusubsystem = true;
            continue;
          }
          if (permissions[i].name == 'equipment_current_status') {
            self.menuequipmentcurrentstatus = true;
            continue;
          }
          if (permissions[i].name == 'equipment_pool_transfer') {
            self.menuequipmentpooltransfer = true;
            continue;
          }
          if (permissions[i].name == 'depreciation_review') {
            self.menudepreciationreview = true;
            continue;
          }
          if (permissions[i].name == 'depreciation_nbv') {
            self.menudepreciationnbv = true;
            continue;
          }
          if (permissions[i].name == 'disposal_invoice') {
            self.menudisposalinvoice = true;
            continue;
          }
          if (permissions[i].name == 'insurance_policy_report') {
            self.menuinsurancepolicyreport = true;
            continue;
          }
          if (permissions[i].name == 'owned_equipment_report') {
            self.menuownedequipmentreport = true;
            continue;
          }
          if (permissions[i].name == 'equipment_master') {
            self.menuequipmentmaster = true;
            continue;
          }
          if (permissions[i].name == 'cost_per_metric_report') {
            self.menucostpermetricreport = true;
            continue;
          }

          if (permissions[i].name == 'equipment_feature_report') {
            self.menuequipmentfeaturereport = true;
            continue;
          }
          if (permissions[i].name == 'gangsheet_detail_report') {
            self.menugangsheetreport = true;
            continue;
          }
          if (permissions[i].name == 'out_of_service_history') {
            self.menuoutofservicehistory = true;
            continue;
          }
          if (permissions[i].name == 'repair_history_report') {
            self.menurepairhistoryreport = true;
            continue;
          }
          if (permissions[i].name == 'inventory_as_at_detail_report') {
            self.menuinventorydetailreport = true;
            continue;
          }
          if (permissions[i].name == 'pm_unit_detail_report') {
            self.menupmunitdetailreport = true;
            continue;
          }
          if (permissions[i].name == 'pm_unit_forecast_report') {
            self.menupmunitforecastreport = true;
            continue;
          }
          if (permissions[i].name == 'pm_compliance_facility_report') {
            self.menupmcompliancefacilityreport = true;
            continue;
          }
          if (permissions[i].name == 'pm_compliance_pool_report') {
            self.menupmcompliancepoolreport = true;
            continue;
          }
          if (permissions[i].name == 'customer_report') {
            self.menucustomerreport = true;
            continue;
          }
          if (permissions[i].name == 'invoice_list_report') {
            self.menuinvoicelistreport = true;
            continue;
          }
          if (permissions[i].name == 'fuel_ticket_detail') {
            self.menufuelticketdetail = true;
            continue;
          }
          if (permissions[i].name == 'unit_permit_detail') {
            self.menuunitpermitdetail = true;
            continue;
          }
          if (permissions[i].name == 'equipment_accounting_records') {
            self.menuhvutunitdetail = true;
            continue;
          }
          if (permissions[i].name == 'hvut_unit_detail') {
            self.menuhvutunitdetail = true;
            continue;
          }
          if (permissions[i].name == 'bill_reading_for_period_report') {
            self.menubillreadingforperiodreport = true;
            continue;
          }
          if (permissions[i].name == 'metrics_billed_report') {
            self.menumetricsbilledreport = true;
            continue;
          }
          if (permissions[i].name == 'net_billing_metrics_for_period') {
            self.menunetbillingmetricsforperiod = true;
            continue;
          }
          if (permissions[i].name == 'lease_contract_report') {
            self.menuleasecontractreport = true;
            continue;
          }
          if (permissions[i].name == 'lease_contract_expiry_report') {
            self.menuleasecontractexpiryreport = true;
            continue;
          }
          if (permissions[i].name == 'lease_rates_utilization_report') {
            self.menuratesandutilizationreport = true;
            continue;
          }
          if (permissions[i].name == 'customer_total_fleet_report') {
            self.totalFleetReport = true;
            continue;
          }
          if (permissions[i].name == 'maintenance_inclusions_and_exclusions_report') {
            self.menucontractcustomerreport = true;
            continue;
          }
          if (permissions[i].name == 'contract_customer_report') {
            self.menucontractcustomerreport = true;
            continue;
          }
          if (permissions[i].name == 'contract_equipment_as_at') {
            self.menucontractequipmentreport = true;
            continue;
          }
          if (permissions[i].name == 'contract_equipment_utilization') {
            self.menucontractequiputilization = true;
            continue;
          }
          if (permissions[i].name == 'lease_rental_current_insurance_policy_review') {
            self.menuleaserentalinsurancereview = true;
            continue;
          }
          if (permissions[i].name == 'available_equipment_report') {
            self.menuavailableequipmentreport = true;
            continue;
          }
          if (permissions[i].name == 'customer_rental_scope_rate_report') {
            self.menucustomerrentalscoperatereport = true;
            continue;
          }
          if (permissions[i].name == 'reservation_listing_report') {
            self.menureservationreport = true;
            continue;
          }
          if (permissions[i].name == 'rental_listing_report') {
            self.menurentallistingreport = true;
            continue;
          }
          if (permissions[i].name == 'rental_activity_report') {
            self.menurentalactivityreport = true;
            continue;
          }
          if (permissions[i].name == 'rental_activity_with_rates_report') {
            self.menurentalactivitywithratesreport = true;
            continue;
          }
          if (permissions[i].name == 'substitute_unit_report') {
            self.menusubstituteunitreport = true;
            continue;
          }
          if (permissions[i].name == 'cpi_rate_verification_report') {
            self.menucpiratereport = true;
            continue;
          }
          if (permissions[i].name == 'weekly_rental_report') {
            self.menuweeklyrentalreport = true;
            continue;
          }
          if (permissions[i].name == 'permit_entry_report') {
            self.menupermitentryreport = true;
            continue;
          }
          if (permissions[i].name == 'list_notes') {
            self.menunotes = true;
            continue;
          }
          if (permissions[i].name == 'warranty_claim_report') {
            self.menuwarrantyclaim = true;
          }
          if (permissions[i].name == 'list_work_order_invoice') {
            self.menuworkorderinvoice = true;
            continue;
          }
          if (permissions[i].name == "ap_positive_pay_listing_report") {
            self.menuappositivepaylistingreport = true;
            continue;
          }
          if (permissions[i].name == "shop_purchase_order_report") {
            self.menushopporeport = true;
            continue;
          }
          if (permissions[i].name == "customer_invoice_line_detail_report") {
            self.menucustomerinvoiceline = true;
            continue;
          }
          if (permissions[i].name == 'debt_note_balance_report') {
            self.menudebtnotebalance = true;
            continue;
          }
          if (permissions[i].name == 'debt_note_unit_detail_report') {
            self.menudebtnoteunitdetail = true;
            continue;
          }
          if (permissions[i].name == 'debt_note_posting_detail_report') {
            self.menudebtnotepostingdetail = true;
            continue;
          }
          if (permissions[i].name == 'list_leave_holiday_calendar') {
            self.menuleaveholidaycalendar = true;
            continue;
          }
          if (permissions[i].name == 'debt_note_schedule_report') {
            self.menudebtnoteschedule = true;
            continue;
          }
          if (permissions[i].name == 'list_comment_type') {
            self.subjectList = true;
            continue;
          }
          if (permissions[i].name == 'list_voucher_payment_maintenance') {
            self.menuvoucherpayment = true;
            continue;
          }
          if (permissions[i].name == "contract_revenue_report") {
            self.menucontractrevenuereport = true;
            continue;
          }
          if (permissions[i].name == "can_see_gl_inquiry") {
            self.menuGLBalance = true;
            continue;
          }
          if (permissions[i].name == "list_fhut_exception") {
            self.menuhvutexception = true;
            continue;
          }
          if (permissions[i].name == 'ev_list_inventory') {
            self.ev_inventory = true;
            continue;
          }
          if (permissions[i].name == 'ev_list_part_order') {
            self.ev_part_order = true;
            continue;
          }
          if (permissions[i].name == 'ev_add_part_order') {
            self.ev_part_order_create = true;
            self.ev_part_order = true;
            continue;
          }
          if (permissions[i].name == 'ev_list_warranty') {
            self.ev_warranty = true;
            continue;
          }
          if (permissions[i].name == 'ev_list_claim') {
            self.ev_claim = true;
            continue;
          }
          if (permissions[i].name == 'ev_list_claim_collection') {
            self.ev_claim_collection = true;
            continue;
          }
          if (permissions[i].name == 'ev_list_vehicle') {
            self.ev_vehicle = true;
            continue;
          }
          if (permissions[i].name == 'ev_list_vehicle_order') {
            self.ev_vehicle_order = true;
            continue;
          }
          if (permissions[i].name == 'ev_add_vehicle_order') {
            self.ev_vehicle_order_add = true;
            self.ev_vehicle_order = true;
            continue;
          }
          if (permissions[i].name == 'ev_list_dealer') {
            self.ev_customer = true;
            continue;
          }
          if (permissions[i].name == 'ev_setting') {
            self.ev_setting = true;
            continue;
          }
          if (permissions[i].name == 'ev_my_vehicles') {
            self.ev_my_vehicle = true;
            continue;
          }
          if (permissions[i].name == 'ev_list_customer') {
            self.evConsumer = true;
            continue;
          }
          if (permissions[i].name == 'ev_list_all_vehicle') {
            self.ev_all_vehicle = true;
            continue;
          }
          if (permissions[i].name == 'ev_list_rate') {
            self.evRate = true;
            continue;
          }
          if (permissions[i].name == 'ev_list_campaign') {
            self.campaignRecall = true;
            continue;
          }
          if (permissions[i].name == 'ev_list_campaign_recall_vin') {
            self.statusTracking = true;
            continue;
          }
          if (permissions[i].name == 'ev_part_catalog') {
            self.ev_part_catalog = true;
            continue;
          }
          if (permissions[i].name == 'ev_list_srt') {
            self.evSrt = true;
            continue;
          }
          if (permissions[i].name == 'ev_view_warranty') {
            self.ev_warranty_menu = true;
            continue;
          }
          if (permissions[i].name == "ev_create_feedback") {
            self.report_concern = true;
            continue;
          }
          if (permissions[i].name == "ev_list_feedback") {
            self.feedback_log = true;
            self.loadFeedbackCount();
            continue;
          }
          if (permissions[i].name == "ev_list_media") {
            self.ev_gallery = true;
            continue;
          }
          if (
            permissions[i].name === "ev_create_technical_support"
            ||
            permissions[i].name === "ev_update_technical_support"
          ) {
            self.technicalSupportRequest = true;
            continue;
          }
          if (permissions[i].name === "ev_list_technical_support") {
            self.technicalSupportQueue = true;
            continue;
          }
          if (permissions[i].name == "ev_list_vehicle_option") {
            self.vehicleOptionCreate = true;
            continue;
          }
          if (permissions[i].name == 'ev_load_all_dealer_dropdown') {
            self.isAdminUser = true;
            continue;
          }
          if (permissions[i].name == 'ev_part_backorder_reporting') {
            self.ev_part_backorder_reporting = true;
          }
          if (permissions[i].name == 'ev_list_retail_delivery_report') {
            self.retailDeliveryReport = true;
            continue;
          }
          if (permissions[i].name == 'ev_claim_credit_memo_log') {
            self.creditMemoLog = true;
            continue;
          }
          if (permissions[i].name === 'ev_list_position_code') {
            self.evPositionCode = true;
          }
        }

        if(self.isAdminUser && self.technicalSupportQueue){
          self.loadTechnicalCount();
        }
      }
      $('#sidebar-wrapper').off('click', '.tree-toggle').on('click', '.tree-toggle', function () {
        $(this).parent().children('ul.tree').toggle(200);
      });
    }
  },

  created(){
    EventBus.$on('updateCount', this.updateCount);
  },
  beforeMount: function () {
    var self = this;
    contex = this;
    // alert(process.env.NODE_ENV);

  },
  beforeDestroy: function () {
    //$(".sidebar-wrapper").children('ul.tree').toggleClass("hide");
    EventBus.$off('updateCount', this.updateCount);
  },
  mounted: function () {

    var self = this;
    // if(process.env.NODE_ENV == 'production' || process.env.NODE_ENV == 'demo' ){
    //     self.enToken = false;
    // }
    //check menu selected...
    var menuLinks = localStorage.getItem("loadMenuLinksFor");
    if (menuLinks == "reports") {
      self.loadMenuLinksFor = "reports";
    } else {
      self.loadMenuLinksFor = "modules";
    }

    //for passing token to url for switch from fleetpro to Rental
    this.token = localStorage.getItem("tkn");
    this.rentalLink = process.env.RENTAL_URL + "?secret=" + this.token;

    // $('#sidebar-wrapper').off('click','.tree-toggle').on('click','.tree-toggle',function () {
    //     $(this).parent().children('ul.tree').toggle(200);
    // });

    var userObj = JSON.parse(localStorage.getItem("user_obj"));
    if (userObj != null) {
      // var userJson = JSON.parse(userObj);
      if (userObj.roles.length > 0) {
        var role = userObj.roles[0].name;
        self.role = role;
      }
      if (userObj.customer_id != null) {
        self.customerIdExist = true;
      } else {
        self.customerIdExist = false;
      }
    }

    if (self.velocity_env == 'velev' || self.velocity_env == 'velev_test') {
      self.isEv = true;
    } else {
      self.isEv = false;
    }
  },
  methods: {
    updateCount(count, flag) {
      if(flag == 'feedback'){
        this.feedbackCount = count;
      } else if (flag == 'technical'){
        this.technicalCount = count;
      }
    },
    loadFeedbackCount(){
      var self = this;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/get-feedback/count",
        type: "GET",
        headers: this.ajxHeaders,
        dataType: 'json',
        success: function (data) {
          self.loading = false;
          if(data.code == 200) {
            self.feedbackCount = data.content;
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'get-feedback-count');
        }
      });
    },
    loadTechnicalCount(){
      var self = this;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/technical-support-get-count",
        type: "GET",
        headers: this.ajxHeaders,
        dataType: 'json',
        success: function (data) {
          self.loading = false;
          if(data.code == 200) {
            self.technicalCount = data.content;
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'get-technical-count');
        }
      });
    },
    showCalendarPage() {
      EventBus.$emit('showCalendarPage', 1);
    },
    showLeaveHolidayPage() {
      EventBus.$emit('showLeaveHolidayPage', 1);
    },
    // check previous selected dashboard
    dashbord() {
      var self = this;
      var prevSelectedTab = localStorage.getItem("landingpage");
      if (prevSelectedTab == null) {
        self.$router.push("/dashboard");
      } else {
        if (prevSelectedTab == 'lease') {
          self.$router.push("/lease-dashboard");
        } else if (prevSelectedTab == 'rental') {
          self.$router.push("/rental-dashboard");
        } else if (prevSelectedTab == 'account') {
          self.$router.push("/account-dashboard");
        } else if (prevSelectedTab == 'service') {
          self.$router.push("/service-dashboard");
        } else {
          self.$router.push("/dashboard");
        }
      }
    }
  }


}

// emit permissions on sidebar
EventBus.$on('user-permissions', function (permissionArr) {
  contex.permissions = permissionArr;
});
EventBus.$on('logged-in', function (isLogin, name, role, username, file_path) {
  contex.userRole = role;
});
EventBus.$on('user-flashit', function (value) {

  $("#unsyncedLink").removeClass("flashit");
  if (value) {
    $("#unsyncedLink").removeClass("flashit");
  } else {
    $("#unsyncedLink").addClass("flashit");
  }
});

//load menu for the report or
EventBus.$on('loadMenuLink', function (flag) {
  contex.loadMenuLinksFor = flag;
});

</script>
<style scoped>
.notification-count-badge {
  position: absolute;
  top: 3px;
  right: 7px;
  color: white;
  font-size: 11px;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: red;
  border-radius: 50%;
  font-weight: bold;
  border: 1px solid white;
  text-indent: 0px !important;
}
.report-concern-link {
  position: fixed;
  bottom: 0px;
  background-color: white;
  overflow: hidden;
  width: 250px !important;
  transition: width 0.5s ease 0s;
  white-space: nowrap;
}

.toggled-2 .report-concern-link {
  width: 55px !important;
  transition: width 0.5s ease 0s;
}

.rental-sidebar-right.toggled-2 #sidebar-wrapper:hover .report-concern-link {
  width: 250px !important;
  transition: width 0.5s ease 0.65s;
}

</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue